import { Badge, Container, Navbar, Button as ButtonStrap } from "react-bootstrap";
import axios from "axios";
import no_image from "../images/No_Image_Available.jpg";
import coverSample from "../images/No_Image_Available.jpg";
import Snapchat from "../images/snapchat.svg";
import Facebook from "../images/facebook-icon.svg";
import Twitter from "../images/twitter.svg";
import Instagram from "../images/instigram.svg";
import Global from "../images/global.svg";
import Whatsapp from "../images/whatsapp.svg";
import Map from "../images/map.svg";
import Tiktok_Light from "../images/tiktok_light.svg";
import SnapchatDarkTheme from "../images/snap-icon-dark-theme.svg";
import FacebookDarkTheme from "../images/facebook-icon-dark-theme.svg";
import TwitterDarkTheme from "../images/x-icon-dark-theme.svg";
import InstagramDarkTheme from "../images/insta-icon-dark-theme.svg";
import WhatsappDarkTheme from "../images/whatsapp-icon-dark-theme.svg";
import MapDarkTheme from "../images/map-dark-icon-theme.svg";
import GlobalDarkTheme from "../images/global-icon-dark-theme.svg";
import Tiktok_Dark from "../images/tiktok_dark.svg";
import {
	Box, Dialog, DialogContent, DialogTitle,
	MenuItem, SwipeableDrawer, Backdrop, CircularProgress,
	Typography,
	Grid,
	Button,
	AppBar,
	Toolbar,
	IconButton,
	Drawer,
	Menu,
	DialogActions,
	TextField
} from "@mui/material";
import {
	AllLanguagesCode,
	generateRandomToken,
	getAndSaveTimeZone,
	getAuth,
	setMobileBackColor,
	setMobileButttonBackColor,
	setMobileCardBorderColor,
	setMobileCardColor,
	setMobileSettings,
	setMobileTextColor,
	setMobileTextField_BK_FONT_Border_StyleColor,

	sendNotificationFirebaseRes,
	ISDARKTHEME,
	setLocalStorageMenuItem,
	getLocalStorageMenuItem,
	setMobileHighlightTextColor,
} from "../utility";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loading from "../common/loading";
import "../css/mobileScreens.css";
import i18next, { t } from "i18next";
import { useEffect, useState } from "react";
import ErrorDialog from "../common/errorDialog";
import MenuAvailabilityComponent from "../components/mobile screen/mobileComponents/MenuAvailabilityComponent";
import {
	ArrowLeftOutlined, ArrowRightOutlined, CloseOutlined,
	Person, LocationOn, Schedule, Restaurant, LocalShipping, TakeoutDining,
	ShoppingCart,
	CheckCircle,
	Payment,
	DeliveryDining,
	LocalDining,
	Home,
	RestaurantMenu,
	ContactMail,
	Share,
	ExpandMore,
	ChevronRight,
	Phone,
	Email,
	TranslateOutlined,
	MapOutlined,
	ChevronLeft
} from "@mui/icons-material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LoginComponent from "../components/mobile screen/mobileComponents/loginComponent";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Import your existing dialog components
import DeliveryDialog from "../components/DeliveryDialog";
import CurrentLocationDialog from "../components/map screens/CurrentLocationDialog";
import NewLocationDialog from "../components/map screens/NewLocationDialog";
import LocationFormDialog from "../components/map screens/LocationFormDialog";
import DeleteLocationDialog from "../components/DeleteLocationDialog";
import Toast from "../common/toast";
import LoadingTreeDataDialog from "../components/mobile screen/mobileComponents/LoadingTreeDataDialog";
import DOMPurify from 'dompurify';
import LocationDistanceDialog from "../components/map screens/LocationDistanceDialog";
// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});



const WellcomeScreen = ({ tableQr, tableName }) => {
	const [params, setParams] = useSearchParams();
	const navigate = useNavigate();

	const [loadingTree, setLoadingTree] = useState(false);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const mobileLoginToken = getLocalStorageMenuItem("mobileLoginToken") || "";
	const [loginDialogOpen, setLoginDialogOpen] = useState(false);

	const [customerBalance, setCustomerBalance] = useState(getLocalStorageMenuItem("customer_balance") || 0);
	const app_mode = getLocalStorageMenuItem("theme");
	const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
	// Order type state
	const [selectedOrderType, setSelectedOrderType] = useState(
		getLocalStorageMenuItem("orderType") || null
	);

	const [locationDistanceDialogOpen, setLocationDistanceDialogOpen] = useState(false);


	const [orderTypeDialogOpen, setOrderTypeDialogOpen] = useState(false);

	const [watingOrders, setWatingOrders] = useState([]);
	const [atDeliveryOrders, setAtDeliveryOrders] = useState([]);
	const [preparingOrders, setPreparingOrders] = useState([]);


	const handleOrderTypeSelection = (type) => {
		setSelectedOrderType(type);
		setLocalStorageMenuItem("orderType", type);
		setOrderTypeDialogOpen(false);
		if (type === "delivery") {
			setDeliveryDialogOpen(true);
			setLocalStorageMenuItem("pendingDelivery", "true");
		} else {
			EnterToSections();
		}

		// setLoginDialogOpen(true);
	};

	// Close order type dialog
	const handleCloseOrderTypeDialog = () => {
		setOrderTypeDialogOpen(false);
	};

	const [toastSettings, setToastSettings] = useState({
		open: false,
		message: "",
		success: false,
	});

	const handleOpenToast = (message, state) => {
		setToastSettings({
			open: true,
			success: state,
			message: message
		});
	};

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setToastSettings({ open: false, message: "", success: false });
	};

	// Delivery workflow state (using your existing structure)
	const [mode, setMode] = useState(null);
	const [selectedPlace, setSelectedPlace] = useState(null);
	const [placeAddress, setPlaceAddress] = useState("");
	const [latLangVal, setLatLangVal] = useState(null);
	const [isEditDelivery, setIsEditDelivery] = useState(false);
	const [isProcessLoading, setIsProcessLoading] = useState(false);
	const [deleteLocationDialogOpen, setDeleteLocationDialogOpen] = useState(false);
	const [deliveryDialogOpen, setDeliveryDialogOpen] = useState(false);
	const [openLocationFormDialog, setOpenLocationFormDialog] = useState(false);
	const [defaultAddress, setDefaultAddress] = useState(null);
	const [savedPlaces, setSavedPlaces] = useState([]);
	const [loadingSavedPlaces, setLoadingSavedPlaces] = useState(false);
	const [sideMenuOpen, setSideMenuOpen] = useState(false);

	const [openComplainDialog, setOpenComplainDialog] = useState(false);
	const [complainForm, setComplainForm] = useState({
		message: ""
	});
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

	const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

	const [showWaitingDialog, setShowWaitingDialog] = useState(false);
	const [showPreparingDialog, setShowPreparingDialog] = useState(false);
	const [showAtDeliveryDialog, setShowAtDeliveryDialog] = useState(false);
	const [currentOrder, setCurrentOrder] = useState(null);

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			setIsMobile(width < 768);
			setIsTablet(width >= 768 && width < 1024);
			setIsDesktop(width >= 1024);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		// Fix for Leaflet icon issues
		const resetLeafletIcons = () => {
			delete L.Icon.Default.prototype._getIconUrl;
			L.Icon.Default.mergeOptions({
				iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
				iconUrl: require('leaflet/dist/images/marker-icon.png'),
				shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
			});
		};

		resetLeafletIcons();
	}, []);





	const calculateEstimatedTime = (order) => {
		if (!order || !order.items || order.items.length === 0) {
			return 0;
		}

		// Calculate average preparation time
		const totalPrepTime = order.items.reduce((sum, item) => {
			return sum + (item.max_preparation_time || 30); // Default 30 minutes if not specified
		}, 0);

		const averagePrepTime = Math.round(totalPrepTime / order.items.length);

		// Add delivery time if order type is delivery
		if (order.type === 'delivery') {
			return averagePrepTime + 30; // Add 30 minutes for delivery
		}

		return averagePrepTime;
	};


	const openOrderDialog = (order, status) => {
		setCurrentOrder(order);
		if (status === 'waiting') {
			setShowWaitingDialog(true);
			setShowPreparingDialog(false);
			setShowAtDeliveryDialog(false);
		} else if (status === 'preparing') {
			setShowPreparingDialog(true);
			setShowWaitingDialog(false);
			setShowAtDeliveryDialog(false);
		} else if (status === 'at_delivery') {
			setShowAtDeliveryDialog(true);
			setShowWaitingDialog(false);
			setShowPreparingDialog(false);
		}
	};

	const {
		data: treeData,
		isLoading: treeDataIsLoading,
		isFetching: treeDataIsFetching,
		isError: treeDataIsError,
		error: treeDataError,
		refetch,
	} = useQuery("treeData", async () => {
		try {
			const language = AllLanguagesCode.filter((lang) => {
				return navigator.language.includes(lang);
			});
			var requestLang = "";

			const langData = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
			);

			if (!getLocalStorageMenuItem("lang")) {
				const selectedLanguage = language[0];
				var checkDefaultLang = langData?.data.data.languages?.some(language => language.code === selectedLanguage)
				if (checkDefaultLang) {
					requestLang = selectedLanguage;
				} else {
					requestLang = langData?.data?.data?.languages[0]?.code;
				}

			} else {
				requestLang = getLocalStorageMenuItem("lang");
			}

			const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
			const promise = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree?table=${params.get('t') || null}`,
				{
					headers: {
						localization: requestLang || getLocalStorageMenuItem("lang"),
						timeZone: timeZone.replace(/["]+/g, '')
					}
				}
			);

			if (promise.status === 200) {
				if (promise?.data?.message === "Plan limit exceeded") {
					setLoadingTree(false);
					setOpenComplainDialog(true);
				} else {
					setLocalStorageMenuItem(
						"tree_data", JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
					);
					setMobileSettings(promise?.data?.data?.details)

				}
			}
			return promise;

		} catch (error) {
			console.log(error)

		}
	});


	const toggleSideMenu = (open) => () => {
		setSideMenuOpen(open);
	};


	const handleComplainSubmit = async () => {
		if (complainForm.message.trim() === "") {
			handleOpenToast(t("Please enter a message"), false);
			return;
		}
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/messages`,
				{
					message: complainForm.message,
					menu_code: tableQr,
					type: "complaint"
				}
			);
			if ((response.status === 200 || response.status === 201) && response?.data?.success) {
				handleOpenToast(t("Your complaint has been submitted successfully"), true);
				setComplainForm({ message: "" });
			}
		} catch (error) {
			console.error("Error submitting complaint:", error);
			handleOpenToast(t("Failed to submit complaint. Please try again."), false);
		}
	};



	// Menu items data


	const initialLocationFormData = {
		title: "",
		street: "",
		unit_number: "",
		floor_number: "",
		apartment_number: "",
		description: "",
		latitude: "",
		longitude: "",
		suburb: "",
		city: "",
		province: "",
		state: "",
		postcode: "",
		country: ""
	};
	const themeSettings = {
		backColor: setMobileBackColor(),
		textColor: setMobileTextColor(),
		cardBorderColor: setMobileCardBorderColor(),
		buttonBackColor: setMobileButttonBackColor(),
		cardColor: setMobileCardColor()
	};

	const [locationFormData, setLocationFormData] = useState(initialLocationFormData);
	const [allTreeData, setAllTreeData] = useState(() => {
		const savedTreeData = getLocalStorageMenuItem("tree_data");
		return savedTreeData ? savedTreeData : [];
	});


	const controls = useAnimation();
	const [ref, inView] = useInView({
		threshold: 0.1,
		triggerOnce: false
	});

	const [slides, setSlides] = useState(null);
	const [currentSlide, setCurrentSlide] = useState(0);

	useEffect(() => {
		if (treeData?.data?.message !== "Plan limit exceeded" && !treeDataIsLoading && (!treeData?.data?.data?.details?.is_available || !treeData?.data?.data?.details || !treeData?.data?.data?.tree || !treeData?.data?.data?.items)) {
			setLoadingTreeDialog(true);
		}
		if (treeData?.data?.data?.details) {
			const slideData = treeData?.data?.data?.details?.slider?.length > 0
				? treeData?.data?.data?.details?.slider.map(item => ({
					image: item.image || treeData?.data?.data?.details?.cover || no_image,
					title: item.text || treeData?.data?.data?.details?.venu_name,
				}))
				: [{
					image: treeData?.data?.data?.details?.cover || no_image,
					title: treeData?.data?.data?.details?.venu_name
				}];

			setSlides(slideData);
			setCurrentSlide(0);
		}
	}, [treeData]);


	useEffect(() => {
		if (!slides || slides?.length <= 1) return;

		const interval = setInterval(() => {
			setCurrentSlide(prev => (prev === slides?.length - 1 ? 0 : prev + 1));
		}, 5000);

		return () => clearInterval(interval);
	}, [slides]);




	useEffect(() => {
		if (inView) {
			controls.start("visible");
		} else {
			controls.start("hidden");
		}
	}, [controls, inView]);

	// Define your animation variants
	const scrollVariants = {
		hidden: {
			opacity: 0,
			y: 50,
			transition: { duration: 0.5 }
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.5 }
		}
	};

	const textOverlayVariants = {
		hidden: {
			opacity: 0,
			y: 20
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 0.8,
				ease: "easeOut"
			}
		}
	};



	const [showHowToOrder, setShowHowToOrder] = useState(true);

	const [anchorlang, setAnchorlang] = useState(null);
	const language = getLocalStorageMenuItem("lang");
	const [showInfoDailog, setShowInfoDailog] = useState(false);

	const openLang = Boolean(anchorlang);

	const howToOrderSteps = [
		{
			icon: <ShoppingCart sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Select Items"),
			description: t("Browse our menu and add items to your cart")
		},
		{
			icon: <CheckCircle sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Review Order"),
			description: t("Check your items and make any changes before checkout")
		},
		{
			icon: <Payment sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Make Payment"),
			description: t("Choose your payment method and complete your order")
		},
		{
			icon: <DeliveryDining sx={{ fontSize: 40, color: themeSettings.buttonBackColor }} />,
			title: t("Receive Order"),
			description: t("Pick up your order or get it completed to your location")
		}
	];




	const handleOpenLoginDialog = (is_from_order) => {
		// if (JSON.parse(params.get("t"))) {
		// 	setLoginDialogOpen(true);
		// } else {
		// 	setOrderTypeDialogOpen(true);
		// }

		setLoginDialogOpen(true);
	};

	const handleCloseLoginDialog = () => {
		setLoginDialogOpen(false);
	};

	const handleVerificationSuccess = (token) => {
		if (token) {
			setLocalStorageMenuItem("mobileLoginToken", token || "");

			setLoginDialogOpen(false);

			// if (getLocalStorageMenuItem("orderType") === "") {
			// 	setOrderTypeDialogOpen(true);
			// } else {
			// 	if (getLocalStorageMenuItem("pendingDelivery")) {
			// 		setDeliveryDialogOpen(true);
			// 		setLocalStorageMenuItem("pendingDelivery", "false");
			// 	}
			// }

			if (treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null") {
				EnterToSections();
			} else {
				setOrderTypeDialogOpen(true);
			}

		}
	};

	const checkLoginToken = () => {
		if (mobileLoginToken && mobileLoginToken?.length > 0) {
			return true;
		}
		return false;
	}

	const toggleDrawer = (open) => () => {
		setDrawerOpen(open);
	};

	const increaseScansCount = async () => {
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/menus/${tableQr}/increase-scans-count`,
				getAuth()
			);
		} catch (error) {
			console.error("Error increasing ScansCount:", error);
		}
	};

	useEffect(() => {
		if (!getLocalStorageMenuItem("gustToken")) {
			setLocalStorageMenuItem("gustToken", generateRandomToken(25));
		}

		getAndSaveTimeZone();

		// Load saved places if user is logged in
		if (mobileLoginToken) {
			fetchSavedPlaces();
			setPublicOrdersData();
		}
	}, [mobileLoginToken]);

	const fetchSavedPlaces = async () => {
		setLoadingSavedPlaces(true);
		try {
			const [placesResponse, defaultResponse] = await Promise.all([
				axios.get(`${process.env.REACT_APP_API}/customer/addresses`, {
					headers: { Authorization: `Bearer ${mobileLoginToken}` }
				}),
				axios.get(`${process.env.REACT_APP_API}/customer/addresses/default`, {
					headers: { Authorization: `Bearer ${mobileLoginToken}` }
				})
			]);

			const defaultAddressId = defaultResponse.data.data?.id;
			const placesWithDefault = placesResponse.data.data.map(place => ({
				...place,
				isDefault: place.id === defaultAddressId
			}));

			setSavedPlaces(placesWithDefault);
			if (defaultResponse.data.data) {
				setDefaultAddress(defaultResponse.data.data);
			}
		} catch (error) {
			console.error("Error fetching addresses:", error);
		} finally {
			setLoadingSavedPlaces(false);
		}
	};

	const handleOrderTypeSelect = (type) => {
		setSelectedOrderType(type);
		setLocalStorageMenuItem("orderType", type);

		if (type === "delivery") {

			if (!mobileLoginToken) {
				setLoginDialogOpen(true);
				setLocalStorageMenuItem("pendingDelivery", "true");
			} else {
				setDeliveryDialogOpen(true);
			}
		} else {
			EnterToSections();
		}
	};

	const handleOptionSelect = (option) => {
		setMode(option);
	};

	const updateLocationFormData = (pickupMapAddress) => {
		setLocationFormData(prev => ({
			...prev,
			unit_number: pickupMapAddress?.house_number || "",
			street: pickupMapAddress?.road || "",
			suburb: pickupMapAddress?.suburb || pickupMapAddress?.neighbourhood || "",
			city: pickupMapAddress?.city || pickupMapAddress?.town || pickupMapAddress?.village || "",
			province: pickupMapAddress?.state || "",
			state: pickupMapAddress?.state || "",
			postcode: pickupMapAddress?.postcode || "",
			country: pickupMapAddress?.country || "",
			description: [
				pickupMapAddress?.road && `${t("Street")}: ${pickupMapAddress?.road}`,
				pickupMapAddress?.house_number && `${t("House Number")}: ${pickupMapAddress?.house_number}`,
				pickupMapAddress?.postcode && `${t("Postal Code")}: ${pickupMapAddress?.postcode}`,
				(pickupMapAddress?.city || pickupMapAddress?.town) &&
				`${t("City")}: ${pickupMapAddress?.city || pickupMapAddress?.town}`,
				pickupMapAddress?.country && `${t("Country")}: ${pickupMapAddress?.country}`
			]
				.filter(Boolean)
				.join(', '),
			additional_notes: ""
		}));
	};



	const getDistanceAndDuration = async (start, end) => {
		try {
			const url = `https://router.project-osrm.org/route/v1/driving/${start.lng},${start.lat};${end.lng},${end.lat}?overview=false`;
			const response = await axios.get(url);
			const data = response.data;

			const distanceInMeters = data.routes[0].distance;
			const durationInSeconds = data.routes[0].duration;

			return {
				distanceInMeters,
				durationInSeconds
			};
		} catch (error) {
			console.error('Error fetching distance and duration:', error);
			return null;
		}
	};

	const handleLocationDistanceConfirm = () => {
		setSelectedOrderType("pickup");
		setLocalStorageMenuItem("orderType", "pickup");
		setLocationDistanceDialogOpen(false);

		setSelectedPlace(null);
		setPlaceAddress("");

		EnterToSections();
	};

	const handleLocationDistanceCancel = () => {
		setLocationDistanceDialogOpen(false);
	};

	const handleSelectPlace = async (place, is_edit) => {
		setLocationFormData(place || {});
		setIsEditDelivery(is_edit);

		const treeDataVals = allTreeData?.details || treeData?.data?.data?.details;

		const venue_latitude = treeDataVals?.venue_latitude;
		const venue_longitude = treeDataVals?.venue_longitude;
		const selectedPlace_latitude = place?.latitude || 0;
		const selectedPlace_longitude = place?.longitude || 0;

		const distanceAndDuration = await getDistanceAndDuration(
			{ lat: venue_latitude, lng: venue_longitude },
			{ lat: selectedPlace_latitude, lng: selectedPlace_longitude }
		);


		if (distanceAndDuration) {
			const { distanceInMeters } = distanceAndDuration;
			const distanceInKm = (distanceInMeters / 1000).toFixed(2);
			if (distanceInKm > 20) {
				// handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
				setLocationDistanceDialogOpen(true);
				return;
			}
		}

		const addressParts = [
			`${t("LocationName")} ${place.title || 'NAN'}`,
			`${t("Street")} ${place.street || 'NAN'}`,
			`${t("Unit No")} ${place.unit_number || 'NAN'}`,
			`${t("Floor No")} ${place.floor_number || 'NAN'}`,
			`${t("Apartment No")} ${place.apartment_number || 'NAN'}`
		];

		setPlaceAddress(addressParts.join(", "));
		setSelectedPlace(place);
		EnterToSections();

		if (!is_edit) {
			await setDefaultAddressApi(place.id);
			resetLocationForm();
			setDeliveryDialogOpen(false);
		}
	};

	const setDefaultAddressApi = async (addressId) => {
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses/${addressId}/default`,
				{},
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);
			if (response.data.success) {
				setDefaultAddress(selectedPlace);
				// Update the saved places to reflect the new default
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error setting default address:", error);
		}
	};

	const handleSaveLocation = async () => {
		setIsProcessLoading(true);
		const newPlace = {
			...locationFormData,
			latitude: latLangVal?.lat + "",
			longitude: latLangVal?.lng + "",
		};

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses`,
				newPlace,
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				setOpenLocationFormDialog(false);
				resetLocationForm();
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error saving location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleUpdateLocation = async () => {
		setIsProcessLoading(true);
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses/${locationFormData.id}`,
				locationFormData,
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				setOpenLocationFormDialog(false);
				resetLocationForm();
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error updating location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleDeleteLocation = async () => {
		setIsProcessLoading(true);
		try {
			const response = await axios.delete(
				`${process.env.REACT_APP_API}/customer/addresses/${selectedPlace.id}`,
				{
					headers: {
						Authorization: `Bearer ${mobileLoginToken}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				setDeleteLocationDialogOpen(false);
				resetLocationForm();
				fetchSavedPlaces();
			}
		} catch (error) {
			console.error("Error deleting location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const resetLocationForm = () => {
		setLocationFormData(initialLocationFormData);
		setLatLangVal(null);
		setIsEditDelivery(false);
	};

	const handleCloseFormDialog = () => {
		setOpenLocationFormDialog(false);
		// resetLocationForm();
	};

	const handleOpenDeleteLocationDialog = (place) => {
		setDeleteLocationDialogOpen(true);
		setSelectedPlace(place);
	};

	const handleSocialPage = (data, type) => {
		if (type === "whatsapp") {
			const phoneNumber = data.replace(/\D/g, "");
			const message = "";
			const encodedMessage = encodeURIComponent(message);
			window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, "_blank");
		} else if (type === "map") {
			const lat = data[0];
			const long = data[1];
			window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${long}`, "_blank");
		} else {
			window.open(data, "_blank");
		}
	};

	const onImageError = (e) => {
		e.target.src = coverSample;
	};

	const {
		data: languageData,
		isLoading: languageisLoading,
		isError: languageIsError,
		error: languageErrroPublic,
	} = useQuery("public-languages", () => {
		try {
			const timeZone = getLocalStorageMenuItem("timezone") || "";
			return axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`, {
				headers: {
					localization: getLocalStorageMenuItem("lang") || "en",
					timeZone: timeZone?.replace(/["]+/g, ''),
				},
			}
			);
		} catch (error) { }
	});

	const setPublicOrdersData = async () => {
		const orders = await axios.get(
			`${process.env.REACT_APP_API}/menus/${tableQr}/public-orders?token=${getLocalStorageMenuItem("mobileLoginToken")}`,
			{ headers: { localization: getLocalStorageMenuItem("lang") || "en", Authorization: `Bearer ${mobileLoginToken}` } }
		);

		if (!orders?.data?.data?.orders || orders?.data?.data?.orders.length === 0) {
			setAtDeliveryOrders([]);
			setWatingOrders([]);
			setPreparingOrders([]);
			return;
		}

		const at_delivery_orders = orders?.data?.data?.orders.filter(order => order.status === "at delivery");
		setAtDeliveryOrders(at_delivery_orders);
		const waiting_orders = orders?.data?.data?.orders.filter(order => order.status === "waiting");
		setWatingOrders(waiting_orders);
		const preparing_orders = orders?.data?.data?.orders.filter(order => order.status === "preparing");
		setPreparingOrders(preparing_orders);
	};

	// const { data: publicData, isLoading: publicIsLoading, isError: publicIsError } = useQuery("public-orders", async () => {
	// 	if (!mobileLoginToken || mobileLoginToken.length === 0) {
	// 		setAtDeliveryOrders([]);
	// 		setWatingOrders([]);
	// 		setPreparingOrders([]);
	// 		return;
	// 	}
	// 	const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
	// 	const orders = await axios.get(
	// 		`${process.env.REACT_APP_API}/menus/${tableQr}/public-orders?token=${getLocalStorageMenuItem("mobileLoginToken")}`,
	// 		{ headers: { localization: getLocalStorageMenuItem("lang") || "en", Authorization: `Bearer ${mobileLoginToken}`, timeZone: timeZone.replace(/["]+/g, '') } }
	// 	);

	// 	if (!orders?.data?.data?.orders || orders?.data?.data?.orders.length === 0) {
	// 		setAtDeliveryOrders([]);
	// 		setWatingOrders([]);
	// 		setPreparingOrders([]);
	// 		return orders;
	// 	}

	// 	const at_delivery_orders = orders?.data?.data?.orders.filter(order => order.status === "at delivery");
	// 	setAtDeliveryOrders(at_delivery_orders);

	// 	const waiting_orders = orders?.data?.data?.orders.filter(order => order.status === "waiting");
	// 	setWatingOrders(waiting_orders);

	// 	const preparing_orders = orders?.data?.data?.orders.filter(order => order.status === "preparing");
	// 	setPreparingOrders(preparing_orders);


	// 	return orders;

	// });





	useEffect(() => {
		const validateLanguage = () => {
			if (languageData?.data?.data?.languages?.length > 0) {
				const availableLanguages = languageData.data.data.languages.map(lang => lang.code);
				const currentLanguage = getLocalStorageMenuItem("lang");

				// If current language is not in available languages, set to first available language
				if (!availableLanguages.includes(currentLanguage)) {
					const firstLanguage = availableLanguages[0];
					setLocalStorageMenuItem("lang", firstLanguage);
					handleLanguagedata(firstLanguage);
				}
			}
		};

		if (languageData && !languageisLoading) {
			validateLanguage();
		}
	}, [languageData, languageisLoading]);




	const handleDefaultLang = () => {
		const language = AllLanguagesCode.filter((lang) => {
			return navigator.language.includes(lang);
		});

		if (language?.length > 0) {
			if (params.get("lang") && params.get("lang")?.length > 0) {
				// Validate if the param language exists in available languages
				const paramLang = params.get("lang");
				const availableLanguages = languageData?.data?.data?.languages?.map(l => l.code) || [];

				if (availableLanguages.includes(paramLang)) {
					i18next.changeLanguage(paramLang);
					document.querySelector("html").lang = paramLang;
					setLocalStorageMenuItem("lang", paramLang);
					if (paramLang === "ar" || paramLang === "fa") {
						document.body.classList.add("arabic-font");
						document.body.classList.remove("latino-font");
					} else {
						document.body.classList.add("latino-font");
						document.body.classList.remove("arabic-font");
					}
					return paramLang;
				}
			}
		}

		if (!getLocalStorageMenuItem("lang")) {
			const selectedLanguage = language[0];
			var checkDefaultLang = languageData?.data.data.languages?.some(language => language.code === selectedLanguage)
			if (checkDefaultLang) {
				i18next.changeLanguage(selectedLanguage);
				document.querySelector("html").lang = selectedLanguage;
				setLocalStorageMenuItem("lang", selectedLanguage);
				if (selectedLanguage === "ar" || selectedLanguage === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}
				return selectedLanguage;
			} else {
				const firstAvailableLang = languageData?.data?.data?.languages[0]?.code || "en";
				i18next.changeLanguage(firstAvailableLang);
				document.querySelector("html").lang = firstAvailableLang;
				setLocalStorageMenuItem("lang", firstAvailableLang);

				if (firstAvailableLang === "ar" || firstAvailableLang === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}

				return firstAvailableLang;
			}
		} else {
			// Validate stored language
			const storedLang = getLocalStorageMenuItem("lang");
			const availableLanguages = languageData?.data?.data?.languages?.map(l => l.code) || [];

			if (!availableLanguages.includes(storedLang)) {
				const firstAvailableLang = availableLanguages[0] || "en";
				i18next.changeLanguage(firstAvailableLang);
				document.querySelector("html").lang = firstAvailableLang;
				setLocalStorageMenuItem("lang", firstAvailableLang);

				if (firstAvailableLang === "ar" || firstAvailableLang === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}

				return firstAvailableLang;
			}

			return storedLang;
		}
	};

	const handleLanguage = (event) => {
		const lang = event.target.value;
		i18next.changeLanguage(lang);
		document.querySelector("html").lang = lang;
		setLocalStorageMenuItem("lang", lang);
		params.set("lang", lang);

		if (lang === "ar" || lang === "fa") {
			document.body.classList.add("arabic-font");
			document.body.classList.remove("latino-font");
		} else {
			document.body.classList.add("latino-font");
			document.body.classList.remove("arabic-font");
		}
		setParams(params);
	};

	const handleClickLang = (event) => {
		setAnchorlang(event.currentTarget);
	};

	const handleCloseLang = () => {
		setAnchorlang(null);
	};

	const handleLanguagedata = async (langCode) => {
		setLoadingTree(true);
		try {
			const timeZone = getLocalStorageMenuItem("timezone") || "";
			const promise = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree?table=${params.get('t') || null}`,
				{
					headers: {
						localization: langCode,
						timeZone: timeZone.replace(/["]+/g, ""),
					},
				}
			);
			await setLocalStorageMenuItem(
				"tree_data",
				JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
			);
			i18next.changeLanguage(langCode);
			document.querySelector("html").lang = langCode;
			setLocalStorageMenuItem("lang", langCode);
			params.set("lang", langCode);
			setParams(params);

			if (langCode === "ar" || langCode === "fa") {
				document.body.classList.add("arabic-font");
				document.body.classList.remove("latino-font");
			} else {
				document.body.classList.add("latino-font");
				document.body.classList.remove("arabic-font");
			}
		} catch (error) {
		} finally {
			setLoadingTree(false);
		}
	};



	if (treeDataError || languageIsError) {
		return <ErrorDialog />;
	}

	if (languageisLoading || treeDataIsLoading) {
		return <Loading backColor={setMobileBackColor()} />;
	}

	const EnterToSections = () => {

		if (treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null") {
			setLocalStorageMenuItem("orderType", "dinein");
		} else if (!JSON.parse(params.get("t")) && getLocalStorageMenuItem("orderType") !== "dinein" && !getLocalStorageMenuItem("orderType")) {
			setLocalStorageMenuItem("orderType", "browse");
		}
		navigate(
			`/${tableName}/${tableQr}/sections?section=0&t=${params.get(
				"t"
			)}&lang=${getLocalStorageMenuItem("lang")}`
			, {
				replace: true
			});
		increaseScansCount();
	}

	const navigateToPhoneNumberVerification = () => {
		navigate(`/${tableName}/${tableQr}/verify-phone?t=${params.get(
			"t"
		)}&lang=${getLocalStorageMenuItem("lang")}`, {
			replace: true
		});
	};

	// Animation variants
	const fadeIn = {
		hidden: { opacity: 0 },
		visible: { opacity: 1, transition: { duration: 0.8 } }
	};

	const slideUp = {
		hidden: { y: 50, opacity: 0 },
		visible: { y: 0, opacity: 1, transition: { duration: 0.6 } }
	};

	const venueLocation = {
		lat: parseFloat(treeData?.data?.data?.details?.venue_latitude) || 0,
		lng: parseFloat(treeData?.data?.data?.details?.venue_longitude) || 0
	};

	const menuItems = [

		{
			text: t('Browse Menu'),
			icon: <RestaurantMenu />,
			action: EnterToSections
		},
		{
			text: t('Opening hours'),
			icon: <Schedule />,
			action: () => {
				setSideMenuOpen(false);
				setDrawerOpen(true);
			}
		},
		{
			text: t('Contact Us'),
			icon: <ContactMail />,
			action: () => window.location.href = `tel:${treeData?.data?.data?.details?.whatsapp}`
		},
		{
			text: t('Follow Us'),
			icon: <Share />,
			action: null, // This will be handled in sub-items
			subItems: [
				treeData?.data?.data?.details?.facebook && {
					text: t('Facebook'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? FacebookDarkTheme : Facebook}
						alt="Facebook"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
				},
				treeData?.data?.data?.details?.instagram && {
					text: t('Instagram'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? InstagramDarkTheme : Instagram}
						alt="Instagram"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
				},
				treeData?.data?.data?.details?.twitter && {
					text: t('Twitter'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? TwitterDarkTheme : Twitter}
						alt="Twitter"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
				},
				treeData?.data?.data?.details?.snapchat && {
					text: 'Snapchat',
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? SnapchatDarkTheme : Snapchat}
						alt="Snapchat"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
				},
				treeData?.data?.data?.details?.public_whatsapp && {
					text: t('WhatsApp'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? WhatsappDarkTheme : Whatsapp}
						alt="WhatsApp"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
				},
				treeData?.data?.data?.details?.tiktok && {
					text: t('TikTok'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? Tiktok_Dark : Tiktok_Light}
						alt="TikTok"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
				},
				treeData?.data?.data?.details?.website && {
					text: t('Website'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? GlobalDarkTheme : Global}
						alt="Website"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(treeData?.data?.data?.details?.website, 'website')
				},
				(treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude) && {
					text: t('Location'),
					icon: <img
						src={getLocalStorageMenuItem("theme") !== "light" ? MapDarkTheme : Map}
						alt="Location"
						style={{ width: 24, height: 24 }}
					/>,
					action: () => handleSocialPage(
						[treeData?.data?.data?.details?.latitude, treeData?.data?.data?.details?.longitude],
						'map'
					)
				},
				treeData?.data?.data?.details?.phone && {
					text: t('Call Us'),
					icon: <Phone style={{ color: setMobileTextColor(), width: 24, height: 24 }} />,
					action: () => window.location.href = `tel:${treeData?.data?.data?.details?.phone}`
				},
				treeData?.data?.data?.details?.email && {
					text: t('Email Us'),
					icon: <Email style={{ color: setMobileTextColor(), width: 24, height: 24 }} />,
					action: () => window.location.href = `mailto:${treeData?.data?.data?.details?.email}`
				}
			].filter(Boolean)
		}
	];

	const handleClickNavigation = async (dist) => {
		const language = getLocalStorageMenuItem("lang");
		if (dist == "profile") {
			const baseUrl = `/${tableName}/${tableQr}/profile?lang=${language}`;
			const tableParam = params.get("t");
			navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
				replace: true
			});
		} else if (dist === "orders") {
			navigate(
				`/${tableName}/${tableQr}/orders?section=0&t=${params.get(
					"t"
				)}&lang=${language}`
				, {
					replace: true
				});
		} else if (dist === "transactions") {
			navigate(
				`/${tableName}/${tableQr}/transactions?section=0&t=${params.get(
					"t"
				)}&lang=${language}`
				, {
					replace: true
				});
		} else if (dist === "favorites") {
			navigate(
				`/${tableName}/${tableQr}/favorites?section=0&t=${params.get("t")}`
				, {
					replace: true
				});
		} else if (dist === "feedback") {
			navigate(
				`/${tableName}/${tableQr}/feedback?section=0&t=${params.get("t")}`
				, {
					replace: true
				});
		} else if (dist === "privacy") {
			navigate(`/${tableName}/${tableQr}/privacy-policy`, {
				replace: true
			});
		} else if (dist === "terms") {
			navigate(`/${tableName}/${tableQr}/terms-and-conditions`, {
				replace: true
			});
		} else if (dist === "logout") {
			await setLocalStorageMenuItem("mobileLoginToken", "");
			const baseUrl = `/${tableName}/${tableQr}/menus?lang=${language}`;
			const tableParam = params.get("t");
			navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl, {
				replace: true
			});
		}
	}

	const hanldeMode = () => {
		if (getLocalStorageMenuItem("theme") === "dark") {
			setLocalStorageMenuItem("theme", "light");
			params.set("theme", "light");
			setParams(params);
		} else {
			setLocalStorageMenuItem("theme", "dark");
			params.set("theme", "dark");
			setParams(params);
		}
	};


	const handleSendNotification = async (title, body) => {
		setIsProcessLoading(true);
		try {
			const sendNotificationRes = await axios.post(
				`${process.env.REACT_APP_API}/general-notification`,
				{
					venue_id: treeData?.data?.data?.details?.venue_id,
					title: title || "",
					message: body || "",
					table: params.get("t") || "",
				}
			);

			const sendNotificationFirebase = await sendNotificationFirebaseRes(
				treeData?.data?.data?.details,
				title || "",
				body || "",
				"notifications"
			);

			if (
				sendNotificationRes?.data?.success &&
				sendNotificationFirebase?.data?.success
			) {
				setIsProcessLoading(false);

				// handleOpenToast(
				//   <div className="alignByLang">
				//     {t("Your notification sent successfully")}
				//   </div>
				//   , true);

				setShowInfoDailog(true);
			} else {
				setIsProcessLoading(false);

				handleOpenToast(
					<div className="alignByLang">
						{t("Error while sending the notification.")}
					</div>
					, false);
			}
		} catch (error) {
			setIsProcessLoading(false);

			handleOpenToast(
				<div className="alignByLang">
					{t("Error while sending the notification.") + " " + error.message}
				</div>
				, false);
		}
	};

	const dialogStyles = {
		backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
		color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
		borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
	};

	const createSanitizedHTML = (html) => {
		return {
			__html: DOMPurify.sanitize(html || '')
		};
	};



	return (
		<div
			className={`min-vh-100`}
			style={{ backgroundColor: setMobileBackColor() }}
		>
			<div
				className={`min-vh-100 ${isDesktop ? '' : ''}`}
				style={{
					backgroundColor:
						getLocalStorageMenuItem("theme") === "dark" ||
							getLocalStorageMenuItem("theme") === "costomize"
							? setMobileBackColor()
							: "",
					backgroundImage:
						getLocalStorageMenuItem("theme") === "dark" ||
							getLocalStorageMenuItem("theme") === "costomize"
							? setMobileBackColor()
							: "",
				}}
			>

				<AppBar className="alignByLang" position="sticky" elevation={0} sx={{
					backgroundColor:
						getLocalStorageMenuItem("theme") === "dark" ||
							getLocalStorageMenuItem("theme") === "costomize"
							? setMobileBackColor()
							: "",

					boxShadow: 'none',
					padding: '8px 16px',
					position: 'sticky',
					top: 0,
					left: 0,
					right: 0,
					zIndex: 1000,
					width: '100%',

				}}>
					<Toolbar sx={{ justifyContent: 'space-between', padding: '0 !important' }}>
						{/* Hamburger Menu Icon */}
						<IconButton
							edge="end"
							color="inherit"
							aria-label="menu"
							onClick={toggleSideMenu(true)}
							sx={{
								color: setMobileTextColor(),
								backgroundColor: 'rgba(255, 255, 255, 0.1)',
								borderRadius: '8px',
								padding: '8px',
								'&:hover': {
									backgroundColor: 'rgba(255, 255, 255, 0.2)'
								}
							}}
						>
							<MenuIcon />
						</IconButton>

						<motion.div>
							{getLocalStorageMenuItem("mobileLoginToken") && (
								<div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
									<div className="sub-font alignByLang text-center">
										{t("Welcome")} {getLocalStorageMenuItem("customer_name")}
									</div>
								</div>
							)}

							<p
								className="mb-1 text-center sub-font"
								style={{ color: setMobileTextColor() }}
							>
								{treeData?.data?.data?.details?.table}
							</p>
						</motion.div>

						{/* Logo */}
						<motion.div whileHover={{ scale: 1.05 }}>
							<img
								src={treeData?.data?.data?.details?.logo || no_image}
								style={{ height: '40px', maxWidth: '150px', objectFit: 'contain', borderRadius: '20px' }}
								onError={onImageError}
								alt="Venue Logo"
							/>
						</motion.div>

					</Toolbar>
				</AppBar>

				<Drawer
					anchor={getLocalStorageMenuItem("lang") === "ar" ? "right" : "left"}
					open={sideMenuOpen}
					onClose={toggleSideMenu(false)}
					sx={{
						'& .MuiDrawer-paper': {
							width: 350,
							backgroundColor: setMobileCardColor(),
							color: setMobileTextColor(),
						}
					}}
					className="alignByLang"
				>

					<div
						className={`mobile-side-bar min-vh-100`}
						style={{
							color: setMobileTextColor(),
							backgroundColor: setMobileCardColor(),
						}}
					>
						<div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">

							<div>
								<img
									src={treeData?.data?.data?.details?.logo || no_image}
									alt="logo"
									style={{ border: `4px solid ${setMobileCardColor()} ` }}
									className="mobile-side-bar-logo"
									onError={onImageError}
								/>
								{/* Add name and balance from localStorage */}

								{getLocalStorageMenuItem("mobileLoginToken") && (
									<div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
										<div className="sub-font alignByLang text-center">
											{t("Welcome")} {getLocalStorageMenuItem("customer_name")}
										</div>
										<div className="sub-font alignByLang text-center">
											{t("Your Balance")} : {customerBalance}
										</div>
									</div>
								)}
							</div>


							<div className="d-flex justify-content-between">
								<div>
									<span
										className="mx-2 pt-0 cursor"
										onClick={toggleSideMenu(false)}
									>
										<CloseOutlined style={{ color: setMobileTextColor() }} />
									</span>
									<span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
										<TranslateOutlined style={{ color: setMobileTextColor() }} />
									</span>
									<Menu
										id="long-menu"
										MenuListProps={{
											"aria-labelledby": "long-button",
										}}
										anchorEl={anchorlang}
										open={openLang}
										onClose={handleCloseLang}
										onClick={handleCloseLang}
										PaperProps={{
											style: {
												maxHeight: 48 * 4.5,
												width: "25ch",
												backgroundColor: setMobileBackColor(),
											},
										}}
									>


										{languageData?.data?.data?.languages?.map((lang) => {
											const currentLang = getLocalStorageMenuItem("lang");
											const isSelected = lang.code === currentLang;

											return (
												<MenuItem
													key={lang.code}
													onClick={() => handleLanguagedata(lang?.code || "en")}
												>
													<li
														className="d-flex justify-content-between align-items-center p-1 sub-font"
														style={{
															color: isSelected
																? setMobileButttonBackColor()
																: setMobileTextColor(),
														}}
													>
														<span style={{ maxWidth: "80%" }}>
															{` ${lang.label} ( ${t(lang.label)} ) `}
														</span>
														<span
															style={{ maxWidth: "10%" }}
															className={`${isSelected ? "d-block" : "d-none"}`}
														>
															<CheckOutlinedIcon />
														</span>
													</li>
												</MenuItem>
											);
										})}
									</Menu>
								</div>
								<div>
									{getLocalStorageMenuItem("theme") !== "costomize" && (
										<span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
											{app_mode === "dark" ? (
												<DarkModeIcon className="mode-icon-dark" />
											) : (
												<LightModeIcon className="mode-icon-light" />
											)}
										</span>
									)}
								</div>
							</div>
						</div>

						{loadingTree && <Loading backColor={setMobileBackColor()} />}

						<div className="p-24">
							<div
								className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
								style={{
									backgroundColor: setMobileBackColor(),
									borderColor: setMobileCardBorderColor(),
									borderWidth: 1,
									borderStyle: "solid",
								}}
							>
								{JSON.parse(params.get("t")) && (
									<>
										<Badge
											onClick={() =>
												handleSendNotification(
													"call waiter",
													"please call waiter for this table"

												)
											}
											style={{
												borderRadius: "8px",
											}}
											className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
										>
											{t("Call Waiter")}
										</Badge>

										{treeData?.data?.data?.details?.notification_buttons_settings
											?.notification_1_active && (
												<Badge
													onClick={() =>
														handleSendNotification(
															treeData?.data?.data?.details?.notification_buttons_settings
																?.notification_1_title,
															treeData?.data?.data?.details?.notification_buttons_settings
																?.notification_1_body
														)
													}
													style={{
														borderRadius: "8px",
													}}
													className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
												>
													{t(
														treeData?.data?.data?.details?.notification_buttons_settings
															?.notification_1_button
													) || ""}
												</Badge>
											)}

										{treeData?.data?.data?.details?.notification_buttons_settings
											?.notification_2_active && (
												<Badge
													onClick={() =>
														handleSendNotification(
															treeData?.data?.data?.details?.notification_buttons_settings
																?.notification_2_title,
															treeData?.data?.data?.details?.notification_buttons_settings
																?.notification_2_body
														)
													}
													style={{
														borderRadius: "8px",
													}}
													className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
												>
													{t(
														treeData?.data?.data?.details?.notification_buttons_settings
															?.notification_2_button
													) || ""}
												</Badge>
											)}
									</>
								)}



								{getLocalStorageMenuItem("mobileLoginToken") &&
									getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
									<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("profile")}>
										{t("My Profile")}
									</p>
								) : (
									""
								)}

								{allTreeData?.details?.order_ability && getLocalStorageMenuItem("mobileLoginToken") ? (
									<p onClick={() => handleClickNavigation("orders")} className="cursor head-font">
										{t("My orders")}
									</p>
								) : (
									""
								)}

								{getLocalStorageMenuItem("mobileLoginToken") &&
									getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
									<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("transactions")}>
										{t("Wallet")}
									</p>
								) : (
									""
								)}

								<p className="m-top-12 cursor head-font" onClick={() => handleClickNavigation("favorites")}>
									{t("Favorites")}
								</p>

								<p onClick={() => handleClickNavigation("feedback")} className="cursor head-font">
									{t("Your opinion Matters!")}
								</p>

								<p onClick={() => handleClickNavigation("privacy")} className="cursor head-font">
									{t("Privacy Policy")}
								</p>

								<p onClick={() => handleClickNavigation("terms")} className="cursor head-font">
									{t("Terms and Conditions")}
								</p>

								{getLocalStorageMenuItem("mobileLoginToken") &&
									getLocalStorageMenuItem("mobileLoginToken")?.length > 0 ? (
									<p onClick={() => handleClickNavigation("logout")} className="cursor head-font">
										{t("Logout")}
									</p>
								) : (
									""
								)}
							</div>
						</div>
						<div style={{ borderBottom: "1px solid #aaa" }}></div>
						<ul className=" mt-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
							{treeData?.data?.data?.details?.facebook && (
								<li className="mx-2">
									<img
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.facebook)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? FacebookDarkTheme : Facebook}
										alt="Facebook icon"
										className="cursor"
									/>
								</li>
							)}
							{treeData?.data?.data?.details?.public_whatsapp && (
								<li className="mx-2">
									<img
										style={{ width: "20px", height: "20px" }}
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.public_whatsapp)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? WhatsappDarkTheme : Whatsapp}
										alt="Whatsapp icon"
										className="cursor"
									/>
								</li>
							)}
							{treeData?.data?.data?.details?.instagram && (
								<li className="mx-2">
									<img
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.instagram)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? InstagramDarkTheme : Instagram}
										alt="Instagram icon"
										className="cursor"
									/>
								</li>
							)}
							{treeData?.data?.data?.details?.twitter && (
								<li className="mx-2">
									<img
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.twitter)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? TwitterDarkTheme : Twitter}
										alt="X icon"
										className="cursor"
									/>
								</li>
							)}
							{treeData?.data?.data?.details?.snapchat && (
								<li className="mx-2">
									<img
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.snapchat)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? SnapchatDarkTheme : Snapchat}
										alt="Snapchat icon"
										className="cursor"
									/>
								</li>
							)}
							{treeData?.data?.data?.details?.website && (
								<li className="mx-2">
									<img
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.website)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? GlobalDarkTheme : Global}
										alt="global icon"
										className="cursor"
									/>
								</li>
							)}
							{treeData?.data?.data?.details?.tiktok && (
								<li className="mx-2">
									<img
										onClick={() => handleSocialPage(treeData?.data?.data?.details?.tiktok)}
										src={ISDARKTHEME(
											getLocalStorageMenuItem("theme") ||
											treeData?.details?.mobile_settings?.theme,
											setMobileBackColor() ||
											treeData?.details?.mobile_settings?.colorProps?.back
										) ? Tiktok_Dark : Tiktok_Light}
										alt="tiktok icon"
										className="cursor"
									/>
								</li>
							)}
						</ul>

						<div>
							<Typography
								className="sub-font"
								variant="body2"
								style={{
									color: setMobileTextColor(),
									opacity: 0.7,
									textAlign: 'center',
									marginTop: '20px',

								}}
							>
								© {new Date().getFullYear()} {t('Aurmenu')}. {t("All rights reserved")}
							</Typography>
						</div>

					</div>



				</Drawer>

				<div className="row p-0 m-0">

					<div className="ms-auto p-0">
						<motion.div
							initial="hidden"
							whileInView="visible"

							variants={scrollVariants}
							className="text-center"

							animate="visible"

							style={{
								borderBottomLeftRadius: '20px',
								borderBottomRightRadius: '20px'
							}}
						>

							<div className={isDesktop ? `slider-desktop-image` : `slider-mobile-image`} style={{
								position: 'relative',
								borderBottomLeftRadius: '20px',
								borderBottomRightRadius: '20px'
							}}>
								{/* Slides */}
								<AnimatePresence mode='wait'>
									<motion.div
										key={currentSlide}
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
										transition={{ duration: 0.5 }}
										style={{
											position: 'absolute',
											width: '100%',
											height: '100%',
											borderBottomLeftRadius: '20px',  // Added
											borderBottomRightRadius: '20px'  // Added
										}}
									>
										<img
											src={slides ? slides[currentSlide].image : no_image}
											onError={onImageError}
											style={{
												width: '100%',
												height: '100%',
												objectFit: 'cover',
												borderBottomLeftRadius: '20px',  // Added
												borderBottomRightRadius: '20px'  // Added

											}}
											alt="Slide"
										/>

										{/* Text Overlay */}
										<div style={{
											position: 'absolute',
											bottom: 0,
											left: 0,
											right: 0,
											padding: '20px',
											background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
											borderBottomLeftRadius: '20px',  // Added
											borderBottomRightRadius: '20px'  // Added
										}}>

											<motion.h3

												initial="hidden"
												whileInView="visible"
												variants={scrollVariants}
												whileHover={{ scale: 1.1 }}
												animate={{ y: 0, opacity: 1 }}
												transition={{ delay: 0.2, duration: 0.5 }}
												style={{
													color: 'white',
													marginBottom: '35px',
													fontSize: '2rem'
												}}
											>
												{slides ? slides[currentSlide].title : ""}
											</motion.h3>
											<motion.p
												initial={{ y: 20, opacity: 0 }}
												animate={{ y: 0, opacity: 1 }}
												transition={{ delay: 0.3, duration: 0.5 }}
												style={{
													color: 'rgba(255,255,255,0.9)',
													fontSize: '1rem'
												}}
											>
												{slides ? slides[currentSlide].subtitle : ""}
											</motion.p>
										</div>
									</motion.div>
								</AnimatePresence>

								{/* Navigation Dots */}

								{slides?.length > 1 && (
									<div style={{
										position: 'absolute',
										bottom: '10px',
										left: '50%',
										transform: 'translateX(-50%)',
										display: 'flex',
										gap: '8px',
										zIndex: 2
									}}>
										{slides?.map((_, index) => (
											<button
												key={index}
												onClick={() => setCurrentSlide(index)}
												style={{
													width: '10px',
													height: '10px',
													borderRadius: '50%',
													border: 'none',
													background: currentSlide === index ? 'white' : 'rgba(255,255,255,0.5)',
													cursor: 'pointer',
													padding: 0
												}}
											/>
										))}
									</div>
								)}


								{/* Navigation Arrows */}
								<button
									onClick={() => setCurrentSlide(prev => (prev === 0 ? slides?.length - 1 : prev - 1))}
									style={{
										position: 'absolute',
										left: '10px',
										top: '50%',
										transform: 'translateY(-50%)',
										background: 'rgba(0,0,0,0.3)',
										border: 'none',
										borderRadius: '50%',
										width: '40px',
										height: '40px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										cursor: 'pointer',
										zIndex: 2,
										color: 'white'
									}}
								>
									<ChevronLeft />
								</button>

								<button
									onClick={() => setCurrentSlide(prev => (prev === slides?.length - 1 ? 0 : prev + 1))}
									style={{
										position: 'absolute',
										right: '10px',
										top: '50%',
										transform: 'translateY(-50%)',
										background: 'rgba(0,0,0,0.3)',
										border: 'none',
										borderRadius: '50%',
										width: '40px',
										height: '40px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										cursor: 'pointer',
										zIndex: 2,
										color: 'white'
									}}
								>
									<ChevronRight />
								</button>

								{(treeData?.data?.data?.details?.is_available && !checkLoginToken()) && (
									<motion.div
										initial="hidden"
										whileInView="visible"
										variants={scrollVariants}
										whileHover={{ scale: 1.1 }}
										style={{
											position: 'absolute',
											bottom: '20px',
											[getLocalStorageMenuItem("lang") === "ar" ? 'right' : 'left']: '20px',
											zIndex: 10
										}}
									>
										<Button
											variant="outlined"
											disabled={!treeData?.data?.data?.details?.is_available || checkLoginToken()}
											className="m-top-12 head-font"
											onClick={() => handleOpenLoginDialog()}
											style={{
												color: setMobileTextColor(),
												backgroundColor: setMobileBackColor(),
												borderColor: setMobileTextColor(),
												borderRadius: '50%',
												width: '50px',
												height: '50px',
												minWidth: 'unset',
												padding: 0
											}}
										>
											<Person style={{ color: setMobileTextColor() }} />
										</Button>
									</motion.div>
								)}
							</div>

						</motion.div>


						<div className="wellcomeScreen" style={{ marginTop: 10 }} >
							<Container style={{ padding: 0 }}>
								<motion.div
									initial="hidden"
									whileInView="visible"

									variants={scrollVariants}
									className="text-center"
									// style={{ paddingLeft: "24px", paddingRight: "24px" }}

									animate="visible"
								>
									<h1
										className="mb-2 head-font"
										style={{ color: setMobileTextColor() }}
									>
										{getLocalStorageMenuItem("tree_data")?.details?.venu_name || treeData?.data?.data?.details?.venu_name}
									</h1>
									{/* <p className="head-font" style={{ color: setMobileTextColor() }}>
									{getLocalStorageMenuItem("tree_data")?.details?.description || treeData?.data?.data?.details?.description}
								</p> */}

									<Box
										className="head-font"
										style={{ color: setMobileTextColor() }}
										dangerouslySetInnerHTML={createSanitizedHTML(getLocalStorageMenuItem("tree_data")?.details?.description || treeData?.data?.data?.details?.description)}

									/>


									{/* Active Orders Status Sections */}
									{(watingOrders.length > 0 || preparingOrders.length > 0 || atDeliveryOrders.length > 0) && (
										<motion.div
											initial="hidden"
											whileInView="visible"
											variants={scrollVariants}
											style={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
												gap: isMobile ? '16px' : '20px',
												margin: isMobile ? '24px 0' : '32px 0',
												padding: isMobile ? '0 16px' : '0 24px'
											}}
										>
											<Typography
												className="head-font"
												variant="h5"
												style={{
													color: themeSettings.textColor,
													fontWeight: 700,
													textAlign: 'center',
													fontSize: isMobile ? '1.5rem' : '1.75rem',
													marginBottom: '8px'
												}}
											>
												{t("Your Active Orders")}
											</Typography>

											{/* At Delivery Orders Section */}
											{atDeliveryOrders.map((order, index) => (
												<motion.div
													key={`delivery-${order.id || index}`}
													initial="hidden"
													whileInView="visible"
													variants={scrollVariants}
													whileHover={{ scale: 1.02 }}
													whileTap={{ scale: 0.98 }}
													onClick={() => openOrderDialog(order, 'at_delivery')}
													style={{
														width: '100%',
														maxWidth: isMobile ? '100%' : '600px',
														backgroundColor: setMobileCardColor(),
														borderRadius: '16px',
														padding: isMobile ? '16px' : '20px',
														border: `2px solid ${setMobileButttonBackColor()}`,
														boxShadow: `0 4px 20px ${setMobileButttonBackColor()}40`,
														cursor: 'pointer',
														transition: 'all 0.3s ease',
													}}
												>
													<div style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														marginBottom: '12px'
													}}>
														<div style={{
															display: 'flex',
															alignItems: 'center',
															gap: '12px'
														}}>
															<motion.div
																animate={{
																	y: [0, -5, 0],
																}}
																transition={{
																	duration: 1.5,
																	repeat: Infinity,
																	ease: "easeInOut"
																}}
															>
																<DeliveryDining sx={{
																	fontSize: isMobile ? 28 : 32,
																	color: setMobileButttonBackColor()
																}} />
															</motion.div>
															<div>
																<Typography
																	className="head-font"
																	variant="h6"
																	style={{
																		color: setMobileTextColor(),
																		fontWeight: 700,
																		fontSize: isMobile ? '1rem' : '1.1rem'
																	}}
																>
																	{t("Delivery In Progress")}
																</Typography>
																<Typography
																	className="sub-font"
																	variant="body2"
																	style={{
																		color: setMobileTextColor(),
																		opacity: 0.8,
																		fontSize: isMobile ? '0.85rem' : '0.9rem'
																	}}
																>
																	{t("Order")} #{order.number || 'N/A'}
																</Typography>
															</div>
														</div>
														<div style={{
															padding: '6px 12px',
															backgroundColor: `${setMobileButttonBackColor()}20`,
															borderRadius: '20px',
															border: `1px solid ${setMobileButttonBackColor()}40`
														}}>
															<Typography
																className="sub-font"
																variant="caption"
																style={{
																	color: setMobileButttonBackColor(),
																	fontWeight: 600,
																	fontSize: '0.75rem'
																}}
															>
																{t("Click to View")}
															</Typography>
														</div>
													</div>

													<div style={{
														display: 'flex',
														alignItems: 'center',
														gap: '10px',
														marginTop: '12px',
														padding: '12px',
														backgroundColor: `${setMobileButttonBackColor()}10`,
														borderRadius: '10px'
													}}>
														<Schedule sx={{
															fontSize: 20,
															color: setMobileButttonBackColor(),
															opacity: 0.9
														}} />
														<div>
															<Typography
																className="sub-font"
																variant="caption"
																style={{
																	color: setMobileTextColor(),
																	opacity: 0.8,
																	fontSize: '0.75rem'
																}}
															>
																{t("Estimated Arrival")}
															</Typography>
															<Typography
																className="head-font"
																variant="body2"
																style={{
																	color: setMobileButttonBackColor(),
																	fontWeight: 700,
																	fontSize: '0.9rem'
																}}
															>
																{t("Any Moment Now")}
															</Typography>
														</div>
													</div>
												</motion.div>
											))}

											{/* Preparing Orders Section */}
											{preparingOrders.map((order, index) => (
												<motion.div
													key={`preparing-${order.id || index}`}
													initial="hidden"
													whileInView="visible"
													variants={scrollVariants}
													whileHover={{ scale: 1.02 }}
													whileTap={{ scale: 0.98 }}
													onClick={() => openOrderDialog(order, 'preparing')}
													style={{
														width: '100%',
														maxWidth: isMobile ? '100%' : '600px',
														backgroundColor: setMobileCardColor(),
														borderRadius: '16px',
														padding: isMobile ? '16px' : '20px',
														border: `2px solid #4CAF50`,
														boxShadow: `0 4px 20px #4CAF5040`,
														cursor: 'pointer',
														transition: 'all 0.3s ease',
													}}
												>
													<div style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														marginBottom: '12px'
													}}>
														<div style={{
															display: 'flex',
															alignItems: 'center',
															gap: '12px'
														}}>
															<motion.div
																animate={{
																	rotate: [0, 10, -10, 0],
																}}
																transition={{
																	duration: 2,
																	repeat: Infinity,
																	ease: "easeInOut"
																}}
															>
																<LocalDining sx={{
																	fontSize: isMobile ? 28 : 32,
																	color: '#4CAF50'
																}} />
															</motion.div>
															<div>
																<Typography
																	className="head-font"
																	variant="h6"
																	style={{
																		color: setMobileTextColor(),
																		fontWeight: 700,
																		fontSize: isMobile ? '1rem' : '1.1rem'
																	}}
																>
																	{order.type === 'dinein' ? t("Dine In in Preparation") :
																		order.type === 'pickup' ? t("Pickup in Preparation") :
																			t("Delivery in Preparation")}
																</Typography>
																<Typography
																	className="sub-font"
																	variant="body2"
																	style={{
																		color: setMobileTextColor(),
																		opacity: 0.8,
																		fontSize: isMobile ? '0.85rem' : '0.9rem'
																	}}
																>
																	{t("Order")} #{order.number || 'N/A'}
																</Typography>
															</div>
														</div>
														<div style={{
															padding: '6px 12px',
															backgroundColor: '#4CAF5020',
															borderRadius: '20px',
															border: `1px solid #4CAF5040`
														}}>
															<Typography
																className="sub-font"
																variant="caption"
																style={{
																	color: '#4CAF50',
																	fontWeight: 600,
																	fontSize: '0.75rem'
																}}
															>
																{t("Click to View")}
															</Typography>
														</div>
													</div>

													<div style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														marginTop: '12px'
													}}>
														<div style={{
															display: 'flex',
															alignItems: 'center',
															gap: '10px',
															padding: '12px',
															backgroundColor: '#4CAF5010',
															borderRadius: '10px',
															flex: 1,
															marginRight: '10px'
														}}>
															<Schedule sx={{
																fontSize: 20,
																color: '#4CAF50',
																opacity: 0.9
															}} />
															<div>
																<Typography
																	className="sub-font"
																	variant="caption"
																	style={{
																		color: setMobileTextColor(),
																		opacity: 0.8,
																		fontSize: '0.75rem'
																	}}
																>
																	{t("Estimated Time")}
																</Typography>
																<Typography
																	className="head-font"
																	variant="body2"
																	style={{
																		color: '#4CAF50',
																		fontWeight: 700,
																		fontSize: '0.9rem'
																	}}
																>
																	{calculateEstimatedTime(order)} {t("minutes")}
																</Typography>
															</div>
														</div>

														{/* Progress indicator */}
														<div style={{
															width: '80px',
															height: '6px',
															backgroundColor: '#4CAF5040',
															borderRadius: '3px',
															overflow: 'hidden'
														}}>
															<motion.div
																initial={{ width: '0%' }}
																animate={{ width: '60%' }}
																transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
																style={{
																	height: '100%',
																	backgroundColor: '#4CAF50',
																	borderRadius: '3px',
																}}
															/>
														</div>
													</div>
												</motion.div>
											))}

											{/* Waiting Orders Section */}
											{watingOrders.map((order, index) => (
												<motion.div
													key={`waiting-${order.id || index}`}
													initial="hidden"
													whileInView="visible"
													variants={scrollVariants}
													whileHover={{ scale: 1.02 }}
													whileTap={{ scale: 0.98 }}
													onClick={() => openOrderDialog(order, 'waiting')}
													style={{
														width: '100%',
														maxWidth: isMobile ? '100%' : '600px',
														backgroundColor: setMobileCardColor(),
														borderRadius: '16px',
														padding: isMobile ? '16px' : '20px',
														border: `2px solid #FFA500`,
														boxShadow: `0 4px 20px #FFA50040`,
														cursor: 'pointer',
														transition: 'all 0.3s ease',
													}}
												>
													<div style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														marginBottom: '12px'
													}}>
														<div style={{
															display: 'flex',
															alignItems: 'center',
															gap: '12px'
														}}>
															{order.type === 'dinein' ? (
																<motion.div
																	animate={{
																		scale: [1, 1.1, 1],
																	}}
																	transition={{
																		duration: 2,
																		repeat: Infinity,
																		ease: "easeInOut"
																	}}
																>
																	<Restaurant sx={{
																		fontSize: isMobile ? 28 : 32,
																		color: '#FFA500'
																	}} />
																</motion.div>
															) : order.type === 'pickup' ? (
																<motion.div
																	animate={{
																		x: [-10, 10, -10],
																	}}
																	transition={{
																		duration: 2,
																		repeat: Infinity,
																		ease: "easeInOut"
																	}}
																>
																	<TakeoutDining sx={{
																		fontSize: isMobile ? 28 : 32,
																		color: '#FFA500'
																	}} />
																</motion.div>
															) : (
																<motion.div
																	animate={{
																		rotate: [0, 360],
																	}}
																	transition={{
																		duration: 4,
																		repeat: Infinity,
																		ease: "linear"
																	}}
																>
																	<Schedule sx={{
																		fontSize: isMobile ? 28 : 32,
																		color: '#FFA500'
																	}} />
																</motion.div>
															)}
															<div>
																<Typography
																	className="head-font"
																	variant="h6"
																	style={{
																		color: setMobileTextColor(),
																		fontWeight: 700,
																		fontSize: isMobile ? '1rem' : '1.1rem'
																	}}
																>
																	{order.type === 'dinein' ? t("Dine In Order Waiting") :
																		order.type === 'pickup' ? t("Pickup Order Waiting") :
																			t("Delivery Order Waiting")}
																</Typography>
																<Typography
																	className="sub-font"
																	variant="body2"
																	style={{
																		color: setMobileTextColor(),
																		opacity: 0.8,
																		fontSize: isMobile ? '0.85rem' : '0.9rem'
																	}}
																>
																	{t("Order")} #{order.number || 'N/A'}
																</Typography>
															</div>
														</div>
														<div style={{
															padding: '6px 12px',
															backgroundColor: '#FFA50020',
															borderRadius: '20px',
															border: `1px solid #FFA50040`
														}}>
															<Typography
																className="sub-font"
																variant="caption"
																style={{
																	color: '#FFA500',
																	fontWeight: 600,
																	fontSize: '0.75rem'
																}}
															>
																{t("Click to View")}
															</Typography>
														</div>
													</div>

													<div style={{
														display: 'flex',
														alignItems: 'center',
														gap: '10px',
														marginTop: '12px',
														padding: '12px',
														backgroundColor: '#FFA50010',
														borderRadius: '10px'
													}}>
														<Schedule sx={{
															fontSize: 20,
															color: '#FFA500',
															opacity: 0.9
														}} />
														<div>
															<Typography
																className="sub-font"
																variant="caption"
																style={{
																	color: setMobileTextColor(),
																	opacity: 0.8,
																	fontSize: '0.75rem'
																}}
															>
																{t("Estimated Prep Time")}
															</Typography>
															<Typography
																className="head-font"
																variant="body2"
																style={{
																	color: '#FFA500',
																	fontWeight: 700,
																	fontSize: '0.9rem'
																}}
															>
																{calculateEstimatedTime(order)} {t("minutes")}
															</Typography>
														</div>
													</div>
												</motion.div>
											))}
										</motion.div>
									)}

									{/* Order Type Buttons Section */}
									{!(treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null") && (
										<motion.div
											initial="hidden"
											whileInView="visible"
											variants={scrollVariants}
											style={{ margin: '24px 0' }}
											animate="visible"
										>
											<div style={{
												borderRadius: '16px',
												padding: isMobile ? '16px' : '24px',
												margin: isMobile ? '0 16px 16px' : '0 24px 24px',
												backgroundColor: themeSettings.cardColor,
												border: `2px solid ${themeSettings.cardBorderColor}`,
												boxShadow: `0 8px 32px ${themeSettings.cardBorderColor}20`,
												background: `linear-gradient(135deg, ${themeSettings.cardColor} 0%, ${themeSettings.cardColor}dd 100%)`,
												transition: 'all 0.3s ease',
											}}>
												{/* Header Section */}
												<motion.div
													initial="hidden"
													whileInView="visible"
													variants={scrollVariants}
													whileHover={{ scale: 1.02 }}
													style={{
														display: 'flex',
														flexDirection: 'column',
														alignItems: 'center',
														marginBottom: isMobile ? '16px' : '24px',
														textAlign: 'center'
													}}
												>
													<div style={{
														width: isMobile ? '50px' : '60px',
														height: isMobile ? '50px' : '60px',
														borderRadius: '50%',
														backgroundColor: `${themeSettings.buttonBackColor}20`,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														marginBottom: isMobile ? '12px' : '16px',
														border: `2px solid ${themeSettings.buttonBackColor}40`
													}}>
														<Restaurant style={{
															fontSize: isMobile ? '24px' : '32px',
															color: themeSettings.buttonBackColor,
														}} />
													</div>

													<Typography
														className="sub-font"
														variant="h5"
														style={{
															color: themeSettings.textColor,
															marginBottom: '8px',
															fontWeight: 700,
															fontSize: isMobile ? '28px' : '30px',
															background: `linear-gradient(45deg, ${themeSettings.textColor}, ${themeSettings.buttonBackColor})`,
															WebkitBackgroundClip: 'text',
															WebkitTextFillColor: 'transparent',
															backgroundClip: 'text'
														}}
													>
														{t("Choose Your Order Type")}
													</Typography>

													<Typography
														className="sub-font"
														variant="body2"
														style={{
															color: themeSettings.textColor,
															opacity: 0.8,
															fontSize: isMobile ? '20px' : '22px',
															maxWidth: isMobile ? '250px' : '300px'
														}}
													>
														{t("Select how you'd like to receive your order")}
													</Typography>
												</motion.div>

												{/* Order Type Buttons Grid */}
												<div style={{
													display: 'grid',
													gridTemplateColumns: isMobile ? '1fr' :
														isTablet ? 'repeat(auto-fit, minmax(200px, 1fr))' :
															'repeat(auto-fit, minmax(220px, 1fr))',
													gap: isMobile ? '12px' : '16px',
													alignItems: 'stretch',
													justifyItems: 'center'
												}}>
													{treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null" ? (
														<motion.div
															initial="hidden"
															whileInView="visible"
															variants={scrollVariants}
															whileHover={{
																scale: 1.05,
																transition: { duration: 0.2 }
															}}
															whileTap={{ scale: 0.95 }}
															style={{ width: '100%', maxWidth: isMobile ? '100%' : '280px' }}
														>
															<Button
																variant="contained"
																onClick={() => handleOrderTypeSelect("dinein")}
																style={{
																	backgroundColor: themeSettings.buttonBackColor,
																	color: '#fff',
																	borderRadius: '16px',
																	fontWeight: 700,
																	textTransform: 'none',
																	fontSize: isMobile ? '14px' : '16px',
																	width: '100%',
																	minHeight: isMobile ? '100px' : '120px',
																	padding: isMobile ? '16px 12px' : '20px 16px',
																	boxShadow: `0 8px 25px ${themeSettings.buttonBackColor}50`,
																	transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
																	display: 'flex',
																	flexDirection: 'column',
																	gap: isMobile ? '8px' : '12px',
																	border: `3px solid ${themeSettings.buttonBackColor}`,
																	background: `linear-gradient(135deg, ${themeSettings.buttonBackColor} 0%, ${themeSettings.buttonBackColor}dd 100%)`,
																	position: 'relative',
																	overflow: 'hidden'
																}}
															>
																{/* Icon and Title Row */}
																<div style={{
																	display: "flex",
																	flexDirection: "row",
																	alignItems: "center",
																	justifyContent: isMobile ? "space-around" : "space-between",
																	width: isMobile ? "50%" : "100%",
																	padding: '0 8px'
																}}>
																	<Restaurant style={{
																		fontSize: isMobile ? '50px' : '62px',
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																		filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
																	}} />
																	<div className="sub-font" style={{
																		fontSize: isMobile ? '32px' : '328px',
																		fontWeight: 800,
																		textShadow: '0 2px 4px rgba(0,0,0,0.3)',
																		letterSpacing: '0.5px',
																		textAlign: 'center',
																		color: setMobileHighlightTextColor() || setMobileTextColor()
																	}}>
																		{t("Dine In")}
																	</div>
																</div>

																{/* Description */}
																<div style={{
																	display: 'flex',
																	flexDirection: 'column',
																	alignItems: 'center',
																	width: '100%'
																}}>
																	<div className="sub-font" style={{
																		fontSize: isMobile ? '18px' : '20px',
																		opacity: 0.95,
																		marginTop: '2px',
																		fontWeight: 500,
																		textShadow: '0 1px 2px rgba(0,0,0,0.2)',
																		letterSpacing: '0.3px',
																		padding: '4px 12px',
																		backgroundColor: 'rgba(255,255,255,0.25)',
																		borderRadius: '20px',
																		backdropFilter: 'blur(10px)',
																		color: setMobileHighlightTextColor() || setMobileTextColor()
																	}}>
																		{t("Eat at venue")}
																	</div>
																</div>
															</Button>
														</motion.div>
													) : null}


													{treeData?.data?.data?.details?.is_delivery_active ? (
														<motion.div
															initial="hidden"
															whileInView="visible"
															variants={scrollVariants}
															whileHover={{
																scale: 1.05,
																transition: { duration: 0.2 }
															}}
															whileTap={{ scale: 0.95 }}
															style={{ width: '100%', maxWidth: isMobile ? '100%' : '280px' }}
														>
															<Button
																variant="contained"
																onClick={() => handleOrderTypeSelect("delivery")}
																style={{
																	backgroundColor: themeSettings.buttonBackColor,
																	color: '#fff',
																	borderRadius: '16px',
																	fontWeight: 700,
																	textTransform: 'none',
																	fontSize: isMobile ? '14px' : '16px',
																	width: '100%',
																	minHeight: isMobile ? '100px' : '120px',
																	padding: isMobile ? '16px 12px' : '20px 16px',
																	boxShadow: `0 8px 25px ${themeSettings.buttonBackColor}50`,
																	transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
																	display: 'flex',
																	flexDirection: 'column',
																	gap: isMobile ? '8px' : '12px',
																	border: `3px solid ${themeSettings.buttonBackColor}`,
																	background: `linear-gradient(135deg, ${themeSettings.buttonBackColor} 0%, ${themeSettings.buttonBackColor}dd 100%)`,
																	position: 'relative',
																	overflow: 'hidden'
																}}
															>
																{/* Icon and Title Row */}
																<div style={{
																	display: "flex",
																	flexDirection: "row",
																	alignItems: "center",
																	justifyContent: isMobile ? "space-around" : "space-between",
																	width: isMobile ? "50%" : "100%",
																	padding: '0 8px'
																}}>
																	<LocalShipping style={{
																		fontSize: isMobile ? '50px' : '62px',
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																		filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
																	}} />
																	<div className="sub-font" style={{
																		fontSize: isMobile ? '32px' : '38px',
																		fontWeight: 800,
																		textShadow: '0 2px 4px rgba(0,0,0,0.3)',
																		letterSpacing: '0.5px',
																		textAlign: 'center',
																		color: setMobileHighlightTextColor() || setMobileTextColor()
																	}}>
																		{t("Delivery")}
																	</div>
																</div>

																{/* Description */}
																<div style={{
																	display: 'flex',
																	flexDirection: 'column',
																	alignItems: 'center',
																	width: '100%'
																}}>

																	<div className="sub-font" style={{
																		fontSize: isMobile ? '18px' : '20px',
																		opacity: 0.95,
																		marginTop: '2px',
																		fontWeight: 500,
																		textShadow: '0 1px 2px rgba(0,0,0,0.2)',
																		letterSpacing: '0.3px',
																		padding: '4px 12px',
																		backgroundColor: 'rgba(255,255,255,0.25)',
																		borderRadius: '20px',
																		backdropFilter: 'blur(10px)',
																		color: setMobileHighlightTextColor() || setMobileTextColor()
																	}}>
																		{t("To your door")}
																	</div>
																</div>
															</Button>
														</motion.div>
													) : null}

													{treeData?.data?.data?.details?.is_pickup_active ? (
														<motion.div
															initial="hidden"
															whileInView="visible"
															variants={scrollVariants}
															whileHover={{
																scale: 1.05,
																transition: { duration: 0.2 }
															}}
															whileTap={{ scale: 0.95 }}
															style={{ width: '100%', maxWidth: isMobile ? '100%' : '280px' }}
														>
															<Button
																variant="contained"
																onClick={() => handleOrderTypeSelect("pickup")}
																style={{
																	backgroundColor: themeSettings.buttonBackColor,
																	color: '#fff',
																	borderRadius: '16px',
																	fontWeight: 700,
																	textTransform: 'none',
																	fontSize: isMobile ? '14px' : '16px',
																	width: '100%',
																	minHeight: isMobile ? '100px' : '120px',
																	padding: isMobile ? '16px 12px' : '20px 16px',
																	boxShadow: `0 8px 25px ${themeSettings.buttonBackColor}50`,
																	transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
																	display: 'flex',
																	flexDirection: 'column',
																	gap: isMobile ? '8px' : '12px',
																	border: `3px solid ${themeSettings.buttonBackColor}`,
																	background: `linear-gradient(135deg, ${themeSettings.buttonBackColor} 0%, ${themeSettings.buttonBackColor}dd 100%)`,
																	position: 'relative',
																	overflow: 'hidden'
																}}
															>
																{/* Icon and Title Row */}
																<div style={{
																	display: "flex",
																	flexDirection: "row",
																	alignItems: "center",
																	justifyContent: isMobile ? "space-around" : "space-between",
																	width: isMobile ? "50%" : "100%",
																	padding: '0 8px'
																}}>
																	<TakeoutDining style={{
																		fontSize: isMobile ? '50px' : '62px',
																		color: setMobileHighlightTextColor() || setMobileTextColor(),
																		filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
																	}} />
																	<div className="sub-font" style={{
																		fontSize: isMobile ? '32px' : '38px',
																		fontWeight: 800,
																		textShadow: '0 2px 4px rgba(0,0,0,0.3)',
																		letterSpacing: '0.5px',
																		textAlign: 'center',
																		color: setMobileHighlightTextColor() || setMobileTextColor()
																	}}>
																		{t("Pickup")}
																	</div>
																</div>

																{/* Description */}
																<div style={{
																	display: 'flex',
																	flexDirection: 'column',
																	alignItems: 'center',
																	width: '100%'
																}}>
																	<div className="sub-font" style={{
																		fontSize: isMobile ? '18px' : '20px',
																		opacity: 0.95,
																		marginTop: '2px',
																		fontWeight: 500,
																		textShadow: '0 1px 2px rgba(0,0,0,0.2)',
																		letterSpacing: '0.3px',
																		padding: '4px 12px',
																		backgroundColor: 'rgba(255,255,255,0.25)',
																		borderRadius: '20px',
																		backdropFilter: 'blur(10px)',
																		color: setMobileHighlightTextColor() || setMobileTextColor()
																	}}>
																		{t("Pick up the order from the branch")}
																	</div>
																</div>
															</Button>
														</motion.div>
													) : null}

												</div>

												{/* Help Text */}
												<motion.div
													initial="hidden"
													whileInView="visible"
													variants={scrollVariants}
													style={{
														textAlign: 'center',
														marginTop: isMobile ? '16px' : '20px',
														padding: isMobile ? '8px' : '12px',
														borderRadius: '8px',
														backgroundColor: `${themeSettings.buttonBackColor}10`,
														border: `1px solid ${themeSettings.buttonBackColor}20`
													}}
												>
													<Typography
														className="sub-font"
														variant="body2"
														style={{
															color: themeSettings.textColor,
															opacity: 0.8,
															fontSize: isMobile ? '16px' : '18px',
															fontStyle: 'italic'
														}}
													>
														{t("Choose your preferred way to enjoy our food")}
													</Typography>
												</motion.div>
											</div>
										</motion.div>
									)}


									{/* Browse Menu Section */}
									<motion.div
										initial="hidden"
										whileInView="visible"
										variants={scrollVariants}
										style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											gap: isMobile ? '12px' : '16px',
											margin: isMobile ? '16px 0' : '24px 0',
											padding: isMobile ? '0 16px' : '0 24px'
										}}
										whileHover={{ scale: 1.02 }}
									>
										{/* Express Text */}
										<motion.div
											initial="hidden"
											whileInView="visible"
											variants={scrollVariants}
											style={{
												borderRadius: '12px',
												padding: isMobile ? '12px' : '16px',
												backgroundColor: themeSettings.cardColor,
												border: `1px solid ${themeSettings.cardBorderColor}`,
												boxShadow: `0 4px 12px ${themeSettings.cardBorderColor}40`,
												transition: 'all 0.3s ease',
												width: '100%',
												maxWidth: isMobile ? '100%' : '600px',
												textAlign: 'center'
											}}
										>
											<Typography
												className="head-font"
												variant="h6"
												style={{
													color: themeSettings.buttonBackColor,
													fontWeight: 700,
													fontSize: isMobile ? '20px' : '22px',
													marginBottom: '8px',
													textTransform: 'uppercase',
													letterSpacing: '0.5px'
												}}
											>
												{t("Quick & Easy Ordering")}
											</Typography>
											<Typography
												className="sub-font"
												variant="body2"
												style={{
													color: themeSettings.textColor,
													opacity: 0.9,
													lineHeight: '1.5',
													fontSize: isMobile ? '18px' : '20px',
													marginBottom: isMobile ? '12px' : '16px'
												}}
											>
												{t("Browse our menu and order in just a few taps - fast, simple, and convenient!")}
											</Typography>

											{/* Browse Menu Button */}
											<ButtonStrap
												variant="outlined"
												onClick={() => EnterToSections()}
												style={{
													borderColor: themeSettings.buttonBackColor,
													backgroundColor: themeSettings.buttonBackColor,
													color: setMobileHighlightTextColor() || setMobileTextColor(),
													padding: isMobile ? '10px 24px' : '12px 32px',
													borderRadius: '8px',
													fontWeight: 600,
													textTransform: 'none',
													fontSize: isMobile ? '14px' : '16px',
													borderWidth: '2px',
													boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
													transition: 'all 0.3s ease',
													width: isMobile ? '100%' : 'auto',
													minWidth: isMobile ? 'auto' : '200px'
												}}
												className="head-font"


											>
												{t("Browse Menu")} →
											</ButtonStrap>
										</motion.div>
									</motion.div>



									<motion.div
										initial="hidden"
										whileInView="visible"

										variants={scrollVariants}
										style={{ margin: '24px 0' }}

										animate="visible"
									>
										<Typography
											className="head-font"
											variant="h6"
											style={{
												color: themeSettings.textColor,
												fontWeight: 600,
												textAlign: 'center',
												fontSize: '30px',
												lineHeight: '1.5',
												letterSpacing: '0.02em',
												textTransform: 'uppercase',
											}}
										>
											{t("How to Order !?")}
										</Typography>

										<motion.div
											initial="hidden"
											whileInView="visible"

											variants={scrollVariants}
											animate={{ opacity: 1, height: 'auto' }}
											transition={{ duration: 0.3 }}
											style={{
												borderRadius: '12px',
												padding: '16px',
												marginBottom: '24px',
											}}
										>
											<Typography
												className="sub-font"
												variant="h6"
												style={{
													marginBottom: '25px',
													fontWeight: 600,
													textAlign: 'center',
													fontSize: '22px',
													lineHeight: '0.5',
													letterSpacing: '0.02em',
													textTransform: 'uppercase',
													color: themeSettings.textColor


												}}
											>
												{t("It's Very Easy !")}
											</Typography>

											<Grid style={{ padding: '16px' }} container spacing={2}>
												{howToOrderSteps.map((step, index) => (
													<Grid item xs={12} sm={6} key={index}>
														<motion.div
															initial="hidden"
															whileInView="visible"

															variants={scrollVariants}
															whileHover={{ scale: 1.02 }}
															style={{
																backgroundColor: themeSettings.cardColor,
																display: 'flex',
																flexDirection: 'column',
																alignItems: 'center',
																padding: '12px',
																textAlign: 'center',
																border: `1px solid ${themeSettings.cardBorderColor}`,
																borderRadius: '8px',
															}}
														>
															{step.icon}
															<Typography
																className="head-font"
																variant="subtitle1"
																style={{
																	color: themeSettings.textColor,
																	fontWeight: 500,
																	margin: '8px 0'
																}}
															>
																{step.title}
															</Typography>
															<Typography
																className="sub-font"
																variant="body2"
																style={{
																	color: themeSettings.textColor,
																	opacity: 0.8
																}}
															>
																{step.description}
															</Typography>
														</motion.div>
													</Grid>
												))}
											</Grid>
										</motion.div>


									</motion.div>



									{/* Location Map Section */}
									{treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude && (
										<>
											<motion.div
												initial="hidden"
												whileInView="visible"

												variants={scrollVariants}
												style={{
													margin: '24px 0',
													borderRadius: '12px',
													overflow: 'hidden',
													boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
													height: '200px',
												}}

												animate="visible"

											>
												<MapContainer
													center={[venueLocation.lat, venueLocation.lng]}
													zoom={15}
													style={{ height: '100%', width: '100%' }}
													zoomControl={false}
													dragging={false}
													touchZoom={false}
													doubleClickZoom={false}
													scrollWheelZoom={false}
													boxZoom={false}
													keyboard={false}
													tap={false}



												>
													<TileLayer

														url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
														attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
													/>
													<Marker position={[venueLocation.lat, venueLocation.lng]}>
														<Popup>
															{treeData?.data?.data?.details?.venu_name}
														</Popup>
													</Marker>
												</MapContainer>
											</motion.div>

											<motion.div
												initial="hidden"
												whileInView="visible"

												variants={scrollVariants}
												style={{ display: 'flex', justifyContent: 'center' }}
												whileHover={{ scale: 1.02 }}
											>
												<ButtonStrap
													className="head-font"
													variant="outlined"
													onClick={() => handleSocialPage(
														[venueLocation.lat, venueLocation.lng],
														'map'
													)}
													style={{
														borderColor: themeSettings.textColor,
														color: themeSettings.textColor,
														padding: '5px 24px',
														borderRadius: '8px',
														fontWeight: 500,
														textTransform: 'none',
														fontSize: '14px',
														width: 'auto',
														borderWidth: '1px'
													}}
												>

													{t("Open in Maps")}
													{" "}
													<MapOutlined />
												</ButtonStrap>
											</motion.div>
										</>
									)}
									{treeData?.data?.data?.details?.facebook ||
										treeData?.data?.data?.details?.public_whatsapp ||
										treeData?.data?.data?.details?.instagram ||
										treeData?.data?.data?.details?.twitter ||
										treeData?.data?.data?.details?.snapchat ||
										treeData?.data?.data?.details?.website ||
										treeData?.data?.data?.details?.tiktok ? (
										<motion.div
											initial="hidden"
											whileInView="visible"

											variants={scrollVariants}
											style={{
												marginTop: '20px',
												padding: '10px 0',
												borderTop: `1px solid ${themeSettings.cardBorderColor}`
											}}

											animate="visible"
										>
											<Typography
												className="head-font"
												variant="h6"
												style={{
													color: themeSettings.textColor,
													marginBottom: '16px',
													fontWeight: 600,
													listStyle: "none"
												}}
											>
												{t("Follow Us")}
											</Typography>

											<div style={{
												display: 'flex',
												justifyContent: 'center',
												flexWrap: 'wrap',
												gap: '16px',
												listStyle: "none"
											}}>
												{treeData?.data?.data?.details?.facebook ? (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? FacebookDarkTheme : Facebook}
															alt="Facebook icon"
															className="cursor"
														/>
													</motion.li>
												) : <></>}
												{treeData?.data?.data?.details?.public_whatsapp ? (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															style={{ width: "22px", height: "22px" }}
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? WhatsappDarkTheme : Whatsapp}
															alt="Whatsapp icon"
															className="cursor"
														/>
													</motion.li>
												) : <></>}
												{treeData?.data?.data?.details?.instagram ? (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? InstagramDarkTheme : Instagram}
															alt="Instagram icon"
															className="cursor"
														/>
													</motion.li>
												) : <></>}
												{treeData?.data?.data?.details?.twitter ? (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? TwitterDarkTheme : Twitter}
															alt="X icon"
															className="cursor"
														/>
													</motion.li>
												) : <></>}
												{treeData?.data?.data?.details?.snapchat && (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? SnapchatDarkTheme : Snapchat}
															alt="Snapchat icon"
															className="cursor"
														/>
													</motion.li>
												)}
												{treeData?.data?.data?.details?.website ? (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.website, 'website')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? GlobalDarkTheme : Global}
															alt="global icon"
															className="cursor"
														/>
													</motion.li>
												) : <></>}
												{treeData?.data?.data?.details?.tiktok ? (
													<motion.li className="mx-2" whileHover={{ scale: 1.2 }}>
														<img
															onClick={() =>
																handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
															}
															src={ISDARKTHEME(
																getLocalStorageMenuItem("theme") ||
																treeData?.details?.mobile_settings?.theme,
																setMobileBackColor() ||
																treeData?.details?.mobile_settings?.colorProps?.back
															) ? Tiktok_Dark : Tiktok_Light}
															alt="global icon"
															className="cursor"
														/>
													</motion.li>
												) : <></>}
											</div>
										</motion.div>
									) : <></>}



									{/* Opening Hours */}
									<motion.div
										initial="hidden"
										whileInView="visible"

										variants={scrollVariants}

										animate="visible"
									>
										<p
											className="text-center head-font alignByLang"
											style={{
												cursor: 'pointer',
												color: setMobileTextColor(),
												marginTop: "20px",
												marginBottom: "10%",
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												gap: '8px'
											}}
											onClick={toggleDrawer(true)}
										>
											<Schedule style={{ fontSize: '20px' }} />
											{t("Opening hours")}
											{getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ?
												<ArrowLeftOutlined /> : <ArrowRightOutlined />}
										</p>
									</motion.div>

									<SwipeableDrawer
										anchor="bottom"
										open={drawerOpen}
										onClose={toggleDrawer(false)}
										onOpen={toggleDrawer(true)}
									>
										<div
											style={{
												width: '100%',
												backgroundColor: setMobileBackColor(),
												position: 'relative',
												padding: '16px',
											}}
											role="presentation"
										>
											<div className="alignByLang" style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "25px" }}>
												<Badge
													className={`${getLocalStorageMenuItem("theme") === "dark" ? "waiting-badge-style-dark" : ""} p-2 font-size-18 sub-font m-1`}
												>
													{getLocalStorageMenuItem("tree_data")?.details?.menu_name || treeData?.data?.data?.details?.menu_name}
												</Badge>
											</div>

											<CloseOutlined
												className="alignByLang"
												onClick={toggleDrawer(false)}
												style={getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fr" ? {
													position: 'absolute',
													top: 10,
													left: 10,
													cursor: 'pointer',
													color: setMobileTextColor()
												} :
													{
														position: 'absolute',
														top: 10,
														right: 10,
														cursor: 'pointer',
														color: setMobileTextColor()
													}}
											/>
											<MenuAvailabilityComponent availability={treeData?.data?.data?.details?.availability || true} />
										</div>
									</SwipeableDrawer>
								</motion.div>

								<LoginComponent
									open={loginDialogOpen}
									handleCloseDialog={handleCloseLoginDialog}
									tableQr={tableQr}
									tableName={tableName}
									onVerificationSuccess={handleVerificationSuccess}
									is_from={3}
								/>

								<Toast
									open={toastSettings.open}
									message={toastSettings.message}
									resetToast={handleCloseToast}
									success={toastSettings.success}
								/>
							</Container>
						</div>
					</div>

					<motion.footer
						initial="hidden"
						whileInView="visible"
						variants={scrollVariants}
						style={{
							backgroundColor: themeSettings.cardColor,
							padding: '12px 8px',
							borderTop: `1px solid ${themeSettings.cardBorderColor}`,
							marginTop: '5px'
						}}
					>
						<Container>
							{/* First Section - Logo and Venue Name */}
							<div style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								marginBottom: '24px',
								padding: 0
							}}>
								<img
									src={treeData?.data?.data?.details?.logo || no_image}
									alt="Venue Logo"
									style={{
										width: '80px',
										height: '80px',
										borderRadius: '50%',
										objectFit: 'cover',
										marginBottom: '16px',
										border: `2px solid ${themeSettings.cardBorderColor}`
									}}
									onError={onImageError}
								/>
								<Typography
									className="head-font"
									variant="h6"
									style={{
										color: themeSettings.textColor,
										fontWeight: 600,
										textAlign: 'center'
									}}
								>
									{treeData?.data?.data?.details?.venu_name}
								</Typography>
							</div>

							{/* Second Section - Links */}
							<div className="alignByLang" style={{
								display: 'flex',
								justifyContent: 'center',
								flexWrap: 'wrap',
								gap: '0px'
							}}>
								{/* Home Link */}
								<Button
									className="sub-font"
									variant="text"
									onClick={EnterToSections}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Home")}
								</Button>

								{/* Profile Link (if logged in) */}
								{getLocalStorageMenuItem("mobileLoginToken") && (
									<Button
										className="sub-font"
										variant="text"
										onClick={() => handleClickNavigation("profile")}
										style={{
											color: themeSettings.textColor,
											textTransform: 'none'
										}}
									>
										{t("My Profile")}
									</Button>
								)}

								{/* Orders Link */}
								{allTreeData?.details?.order_ability && getLocalStorageMenuItem("mobileLoginToken") && (
									<Button
										className="sub-font"
										variant="text"
										onClick={() => handleClickNavigation("orders")}
										style={{
											color: themeSettings.textColor,
											textTransform: 'none'
										}}
									>
										{t("My orders")}
									</Button>
								)}

								{/* Wallet Link */}
								{getLocalStorageMenuItem("mobileLoginToken") && (
									<Button
										className="sub-font"
										variant="text"
										onClick={() => handleClickNavigation("transactions")}
										style={{
											color: themeSettings.textColor,
											textTransform: 'none'
										}}
									>
										{t("Wallet")}
									</Button>
								)}

								{/* Favorites Link */}
								<Button
									className="sub-font"
									variant="text"
									onClick={() => handleClickNavigation("favorites")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Favorites")}
								</Button>

								{/* Feedback Link */}
								<Button
									className="sub-font"
									variant="text"
									onClick={() => handleClickNavigation("feedback")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Your opinion Matters!")}
								</Button>

								{/* Privacy Policy Link */}
								<Button
									className="sub-font"
									variant="text"
									onClick={() => handleClickNavigation("privacy")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Privacy Policy")}
								</Button>

								{/* Terms and Conditions Link */}
								<Button
									className="sub-font"
									variant="text"
									onClick={() => handleClickNavigation("terms")}
									style={{
										color: themeSettings.textColor,
										textTransform: 'none'
									}}
								>
									{t("Terms and Conditions")}
								</Button>

								{/* Logout Link (if logged in) */}
								{getLocalStorageMenuItem("mobileLoginToken") && (
									<Button
										className="sub-font"
										variant="text"
										onClick={() => handleClickNavigation("logout")}
										style={{
											color: themeSettings.textColor,
											textTransform: 'none'
										}}
									>
										{t("Logout")}
									</Button>
								)}
							</div>

							<Typography
								className="sub-font"
								variant="body2"
								style={{
									color: themeSettings.textColor,
									opacity: 0.7,
									textAlign: 'center',
									marginTop: '24px'
								}}
							>
								© {new Date().getFullYear()} {t('Aurmenu')}. {t("All rights reserved")}
							</Typography>
						</Container>
					</motion.footer>

				</div>

				{/* Delivery Workflow Dialogs */}
				<DeliveryDialog
					open={deliveryDialogOpen}
					savedPlaces={savedPlaces}
					isLoadingSavedPlaces={loadingSavedPlaces}
					openLocationFormDailog={() => setOpenLocationFormDialog(true)}
					onClose={() => setDeliveryDialogOpen(false)}
					onSelect={handleOptionSelect}
					onSelectPlace={handleSelectPlace}
					openDeleteLocationDialog={handleOpenDeleteLocationDialog}
				/>

				<CurrentLocationDialog
					open={mode === "current"}
					onClose={() => setMode(null)}
					setLatLangVal={setLatLangVal}
					updateLocationFormData={updateLocationFormData}
					setMobileBackColor={setMobileBackColor}
					setMobileTextColor={setMobileTextColor}
					setMobileCardBorderColor={setMobileCardBorderColor}
				/>

				<NewLocationDialog
					open={mode === "new"}
					onClose={() => setMode(null)}
					openLocationFormDailog={() => setOpenLocationFormDialog(true)}
					closeLocationFormDailog={() => handleCloseFormDialog()}
					setLatLangVal={setLatLangVal}
					closeMapModal={() => setMode(null)}
					updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
					setMobileBackColor={setMobileBackColor}
					setMobileTextColor={setMobileTextColor}
					setMobileCardBorderColor={setMobileCardBorderColor}
				/>

				<LocationFormDialog
					open={openLocationFormDialog}
					onClose={handleCloseFormDialog}
					isEditDelivery={isEditDelivery}
					isProcessLoading={isProcessLoading}
					locationFormData={locationFormData}
					handleLocationFormInputChange={(e) => {
						setLocationFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
					}}
					handleSaveLocation={handleSaveLocation}
					handleUpdateLocation={handleUpdateLocation}
					setMobileBackColor={setMobileBackColor}
					setMobileTextColor={setMobileTextColor}
					setMobileCardBorderColor={setMobileCardBorderColor}
					setMobileCardColor={setMobileCardColor}
					setMobileButttonBackColor={setMobileButttonBackColor}
				/>

				<DeleteLocationDialog
					onDeleteDeleteLocationDialog={handleDeleteLocation}
					deleteLocationDialogOpen={deleteLocationDialogOpen}
					onCloseDeleteLocationDialog={() => setDeleteLocationDialogOpen(false)}
				/>

				<Backdrop open={isProcessLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
					<CircularProgress color="inherit" />
				</Backdrop>


				<Dialog
					open={showInfoDailog}
					onClose={() => setShowInfoDailog(false)}
					maxWidth="sm"
					PaperProps={{
						style: {
							borderRadius: 15,
							padding: "20px",
							backgroundColor: dialogStyles.backgroundColor,
							border: `1px solid ${setMobileCardBorderColor()}'}`,
						},
					}}
				>
					<DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
						<Typography variant="h6" fontWeight="bold" color={setMobileTextColor()}>
							{t("Hi")}
						</Typography>
					</DialogTitle>
					<DialogContent>
						<Box sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
							<Typography variant="body1" textAlign="center" color={dialogStyles.color}>
								{t("Your order sent and it will be with you as sson as possible, Thank you.")}
							</Typography>
						</Box>
					</DialogContent>
					<DialogActions sx={{ justifyContent: "center" }}>
						<Button
							onClick={() => setShowInfoDailog(false)}
							sx={{
								backgroundColor: setMobileCardBorderColor(),
								color: '#fff',
								padding: "8px 16px",
								borderRadius: "30px",
								"&:hover": {
									backgroundColor: setMobileCardBorderColor(),
								},
							}}
						>
							{t("ok")}
						</Button>
					</DialogActions>
				</Dialog>
				{/* show dailog when open to tell the customer the your order at delivery and it may deliverd at any moment now  */}


				<LoadingTreeDataDialog
					openTreeDialogFlag={loadingTreeDialog}
					onClose={() => setLoadingTreeDialog(false)}
					tableName={tableName}
					tableQr={tableQr}
					from_home={true}
					openAvailability={() => setDrawerOpen(true)}
				/>

				{/* customer complain form dialog */}
				<Dialog
					open={openComplainDialog}
					maxWidth="sm"
					fullWidth
					PaperProps={{
						style: {
							borderRadius: 15,
							padding: "20px",
							backgroundColor: dialogStyles.backgroundColor,
							border: `1px solid ${setMobileCardBorderColor()}'}`,
						},
					}}
				>
					<DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
						<Typography className="head-font" variant="h6" fontWeight="bold" color={setMobileTextColor()}>
							{t("There is a problem in this menu ,send message to us")}
						</Typography>
					</DialogTitle>
					<DialogContent>
						<Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>

							<TextField
								// label={t("Message")}
								name="message"
								value={complainForm.message}
								onChange={(e) => setComplainForm(prev => ({ ...prev, message: e.target.value }))}
								fullWidth
								margin="normal"
								variant="outlined"
								multiline
								placeholder={t("Enter your message")}
								rows={4}
								InputProps={{
									style: { color: setMobileTextColor() },
								}}
								InputLabelProps={{
									style: { color: dialogStyles.color },
								}}
							/>
						</Box>
					</DialogContent>
					<DialogActions sx={{ justifyContent: "center" }}>
						<Button
							onClick={handleComplainSubmit}
							sx={{
								backgroundColor: setMobileButttonBackColor(),
								color: '#fff',
								padding: "8px 16px",
								borderRadius: "30px",
								"&:hover": {
									backgroundColor: setMobileButttonBackColor(),
								},
							}}
						>
							{t("Submit")}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={orderTypeDialogOpen}
					onClose={handleCloseOrderTypeDialog}
					PaperProps={{
						style: {
							backgroundColor: setMobileBackColor(),
							color: setMobileTextColor(),
							borderRadius: '12px',
							padding: '16px',
						},
					}}
				>
					<DialogTitle style={{ textAlign: 'center', padding: '16px' }}>
						<Typography className="head-font" variant="h6" style={{ fontWeight: 'bold' }}>
							{t("Select Order Type")}
						</Typography>
					</DialogTitle>
					<DialogContent style={{ padding: '20px' }}>
						<div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

							{treeData?.data?.data?.details?.is_delivery_active ? (
								<Button
									className="sub-font"
									variant="outlined"
									onClick={() => handleOrderTypeSelection("delivery")}
									style={{
										padding: '12px',
										borderRadius: '8px',
										borderColor: setMobileCardBorderColor(),
										color: setMobileTextColor(),
										justifyContent: 'flex-start',
									}}
									startIcon={<LocalShipping />}
								>
									<div className="alignByLang sub-font" >
										<div className="head-font" style={{ fontWeight: 'bold' }}>{t("Delivery")}</div>
										<div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
											{t("Get your order completed to your location")}
										</div>
									</div>
								</Button>
							) : null}



							{treeData?.data?.data?.details?.is_pickup_active ? (
								<Button
									className="head-font"
									variant="outlined"
									onClick={() => handleOrderTypeSelection("pickup")}
									style={{
										padding: '12px',
										borderRadius: '8px',
										borderColor: setMobileCardBorderColor(),
										color: setMobileTextColor(),
										justifyContent: 'flex-start',
									}}
									startIcon={<TakeoutDining />}
								>
									<div className="alignByLang sub-font">
										<div className="head-font" style={{ fontWeight: 'bold' }}>{t("Pickup")}</div>
										<div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
											{t("Order online and pick up at the venue")}
										</div>
									</div>
								</Button>
							) : null}
							{treeData?.data?.data?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null" ? (
								<Button
									className="head-font"
									variant="outlined"
									onClick={() => handleOrderTypeSelection("dinein")}
									style={{
										padding: '12px',
										borderRadius: '8px',
										borderColor: setMobileCardBorderColor(),
										color: setMobileTextColor(),
										justifyContent: 'flex-start',
									}}
									startIcon={<Restaurant />}
								>
									<div className="alignByLang sub-font">
										<div className="head-font" style={{ fontWeight: 'bold' }}>{t("Dine In")}</div>
										<div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
											{t("Enjoy your meal at our venue")}
										</div>
									</div>
								</Button>
							) : null}

						</div>
					</DialogContent>
					<DialogActions style={{ padding: '16px', justifyContent: 'center' }}>
						<Button
							className="head-font"
							onClick={handleCloseOrderTypeDialog}
							style={{
								color: setMobileTextColor(),
								borderColor: setMobileCardBorderColor(),
							}}
							variant="outlined"
						>
							{t("Cancel")}
						</Button>
					</DialogActions>
				</Dialog>

				{/* Delivery Status Dialog */}
				<Dialog
					open={showAtDeliveryDialog && currentOrder}
					onClose={() => setShowAtDeliveryDialog(false)}
					maxWidth="sm"
					fullWidth
					PaperProps={{
						style: {
							borderRadius: 16,
							overflow: 'hidden',
							backgroundColor: setMobileBackColor(),
							border: `2px solid ${setMobileButttonBackColor()}`,
							maxHeight: '98vh',
						},
					}}
				>
					<motion.div
						initial={{ opacity: 0, scale: 0.9 }}
						animate={{ opacity: 1, scale: 1 }}
						transition={{ duration: 0.3 }}
					>
						{/* Compact Header */}
						<div style={{
							background: `linear-gradient(135deg, ${setMobileButttonBackColor()} 0%, ${setMobileBackColor() || setMobileButttonBackColor()} 100%)`,
							padding: '20px',
							textAlign: 'center',
							position: 'relative',
						}}>
							{/* Animated delivery icon */}
							<motion.div
								animate={{
									y: [0, -5, 0],
								}}
								transition={{
									duration: 1.5,
									repeat: Infinity,
									ease: "easeInOut"
								}}
								style={{
									marginBottom: '12px'
								}}
							>
								<DeliveryDining sx={{
									fontSize: 48,
									color: setMobileButttonBackColor(),
									filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
								}} />
							</motion.div>

							<Typography
								variant="h6"
								className="head-font"
								style={{
									color: setMobileTextColor(),
									fontWeight: 700,
									marginBottom: '4px',
									fontSize: '1.25rem'
								}}
							>
								{t("Delivery In Progress")}
							</Typography>

							<Typography
								variant="caption"
								className="sub-font"
								style={{
									color: setMobileButttonBackColor(),
									fontWeight: 500,
									fontSize: '0.85rem'
								}}
							>
								{t("Your order is on the way")}
							</Typography>
						</div>

						<DialogContent sx={{
							padding: '20px 20px 0px 20px !important',
							'&.MuiDialogContent-root': {
								paddingBottom: '0px !important'
							}
						}}>							{/* Progress indicator */}
							<motion.div
								initial={{ scaleX: 0 }}
								animate={{ scaleX: 1 }}
								transition={{ duration: 0.6 }}
								style={{
									height: 4,
									background: `linear-gradient(90deg, ${setMobileButttonBackColor()} 0%, ${setMobileHighlightTextColor() || setMobileButttonBackColor()} 100%)`,
									borderRadius: 2,
									marginBottom: 20,
									transformOrigin: 'left'
								}}
							/>

							{/* Compact Order status card */}
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ duration: 0.3, delay: 0.2 }}
								style={{
									backgroundColor: setMobileCardColor(),
									borderRadius: 12,
									padding: '16px',
									border: `1px solid ${setMobileCardBorderColor()}`,
									boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
								}}
							>
								{/* Status badge */}
								<div className="alignByLang" style={{
									display: 'flex',
									alignItems: 'center',
									gap: '8px',
									marginBottom: '16px'
								}}>
									<div style={{
										width: 8,
										height: 8,
										borderRadius: '50%',
										backgroundColor: setMobileButttonBackColor(),
										animation: 'pulse 1.5s infinite'
									}} />
									<Typography
										variant="body2"
										className="head-font"
										style={{
											color: setMobileButttonBackColor(),
											fontWeight: 700,
											fontSize: '0.9rem'
										}}
									>
										{t("Out for Delivery")}
									</Typography>
								</div>

								{/* Order details */}
								<div className="alignByLang" style={{ marginBottom: '16px' }}>
									<Typography
										variant="body2"
										className="head-font"
										style={{
											color: setMobileTextColor(),
											fontWeight: 600,
											marginBottom: '4px',
											fontSize: '0.95rem'
										}}
									>
										{t("Order Number :")} {atDeliveryOrders[0]?.number || 'N/A'}
									</Typography>

									{atDeliveryOrders[0]?.items && (
										<Typography
											variant="caption"
											className="sub-font"
											style={{
												color: setMobileTextColor(),
												opacity: 0.7,
												lineHeight: 1.4,
												fontSize: '0.8rem'
											}}
										>
											{atDeliveryOrders[0].items.slice(0, 2).map(item => item.name).join(', ')}
											{atDeliveryOrders[0].items.length > 2 && '...'}
										</Typography>
									)}
								</div>

								{/* Estimated time */}
								<div className="alignByLang" style={{
									display: 'flex',
									alignItems: 'center',
									gap: '10px',
									padding: '12px',
									backgroundColor: `${setMobileButttonBackColor()}08`,
									borderRadius: '8px',
									borderLeft: `3px solid ${setMobileButttonBackColor()}`
								}}>
									<Schedule sx={{
										fontSize: 20,
										color: setMobileButttonBackColor(),
										opacity: 0.9
									}} />
									<div>
										<Typography
											variant="caption"
											className="head-font"
											style={{
												color: setMobileTextColor(),
												fontWeight: 600,
												marginBottom: '2px',
												fontSize: '0.75rem',
												opacity: 0.8
											}}
										>
											{t("Estimated Arrival Time")}
										</Typography>
										<Typography
											variant="body2"
											className="sub-font"
											style={{
												color: setMobileTextColor(),
												fontWeight: 700,
												fontSize: '0.9rem'
											}}
										>
											{t("Any Moment Now")}
										</Typography>
									</div>
								</div>
							</motion.div>

							{/* Mini animation */}
							<div style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								margin: '8px 0 4px',
								height: 30
							}}>
								<motion.div
									animate={{
										x: [-20, 20, -20],
										rotate: [0, 5, 0, -5, 0]
									}}
									transition={{
										duration: 2,
										repeat: Infinity,
										ease: "easeInOut"
									}}
								>
									<LocalShipping sx={{
										fontSize: 24,
										color: setMobileButttonBackColor(),
										opacity: 0.7
									}} />
								</motion.div>
								<div style={{
									width: 60,
									height: 2,
									backgroundColor: `${setMobileButttonBackColor()}40`,
									margin: '0 8px'
								}} />
								<Home sx={{
									fontSize: 24,
									color: setMobileButttonBackColor(),
									opacity: 0.7
								}} />
							</div>

							{/* Compact instruction */}
							<Typography
								variant="caption"
								className="sub-font"
								style={{
									color: setMobileTextColor(),
									opacity: 0.6,
									textAlign: 'center',
									display: 'block',
									fontSize: '0.75rem',
									marginTop: '8px'
								}}
							>
								{t("Please keep your phone nearby")}
							</Typography>
						</DialogContent>

						<DialogActions sx={{
							padding: '5px 20px 5px',
							justifyContent: 'center'
						}}>
							<motion.div
								whileHover={{ scale: 1.03 }}
								whileTap={{ scale: 0.97 }}
							>
								<Button
									onClick={() => setShowAtDeliveryDialog(false)}
									variant="contained"
									sx={{
										backgroundColor: setMobileButttonBackColor(),
										color: setMobileHighlightTextColor() || '#fff',
										padding: '8px 24px',
										borderRadius: '8px',
										fontWeight: 600,
										fontSize: '0.9rem',
										textTransform: 'none',
										minWidth: 120,
										'&:hover': {
											backgroundColor: setMobileButttonBackColor(),
											opacity: 0.9,
										}
									}}
									className="head-font"
								>
									{t("Got It")}
								</Button>
							</motion.div>
						</DialogActions>
					</motion.div>
					{/* Add CSS for pulse animation */}
					<style>
						{`
      @keyframes pulse {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
      }
    `}
					</style>
				</Dialog>

				<Dialog
					open={showWaitingDialog && currentOrder}
					onClose={() => setShowWaitingDialog(false)}
					maxWidth="sm"
					fullWidth
					PaperProps={{
						style: {
							borderRadius: 16,
							overflow: 'hidden',
							backgroundColor: setMobileBackColor(),
							border: `2px solid ${setMobileButttonBackColor()}`,
							maxHeight: '98vh',
						},
					}}
				>
					<motion.div
						initial={{ opacity: 0, scale: 0.9 }}
						animate={{ opacity: 1, scale: 1 }}
						transition={{ duration: 0.3 }}
					>
						{/* Header based on order type */}
						<div style={{
							background: `linear-gradient(135deg, ${setMobileButttonBackColor()} 0%, ${setMobileBackColor() || setMobileButttonBackColor()} 100%)`,
							padding: '20px',
							textAlign: 'center',
							position: 'relative',
						}}>
							{/* Animated icon based on order type */}
							<motion.div
								animate={{
									y: [0, -5, 0],
								}}
								transition={{
									duration: 1.5,
									repeat: Infinity,
									ease: "easeInOut"
								}}
								style={{
									marginBottom: '12px'
								}}
							>
								{currentOrder?.type === 'dinein' ? (
									<Restaurant sx={{
										fontSize: 48,
										color: setMobileButttonBackColor(),
										filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
									}} />
								) : currentOrder?.type === 'pickup' ? (
									<TakeoutDining sx={{
										fontSize: 48,
										color: setMobileButttonBackColor(),
										filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
									}} />
								) : (
									<Schedule sx={{
										fontSize: 48,
										color: setMobileButttonBackColor(),
										filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
									}} />
								)}
							</motion.div>

							<Typography
								variant="h6"
								className="head-font"
								style={{
									color: setMobileTextColor(),
									fontWeight: 700,
									marginBottom: '4px',
									fontSize: '1.25rem'
								}}
							>
								{currentOrder?.type === 'dinein' ? t("Dine In Order Received") :
									currentOrder?.type === 'pickup' ? t("Pickup Order Received") :
										t("Delivery Order Received")}
							</Typography>

							<Typography
								variant="caption"
								className="sub-font"
								style={{
									color: setMobileButttonBackColor(),
									fontWeight: 500,
									fontSize: '0.85rem'
								}}
							>
								{t("Your order is being processed")}
							</Typography>
						</div>

						<DialogContent sx={{
							padding: '20px 20px 0px 20px !important',
							'&.MuiDialogContent-root': {
								paddingBottom: '0px !important'
							}
						}}>
							{/* Progress indicator */}
							<motion.div
								initial={{ scaleX: 0 }}
								animate={{ scaleX: 1 }}
								transition={{ duration: 0.6 }}
								style={{
									height: 4,
									background: `linear-gradient(90deg, ${setMobileButttonBackColor()} 0%, ${setMobileHighlightTextColor() || setMobileButttonBackColor()} 100%)`,
									borderRadius: 2,
									marginBottom: 20,
									transformOrigin: 'left'
								}}
							/>

							{/* Order status card */}
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ duration: 0.3, delay: 0.2 }}
								style={{
									backgroundColor: setMobileCardColor(),
									borderRadius: 12,
									padding: '16px',
									border: `1px solid ${setMobileCardBorderColor()}`,
									boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
								}}
							>
								{/* Status badge */}
								<div className="alignByLang" style={{
									display: 'flex',
									alignItems: 'center',
									gap: '8px',
									marginBottom: '16px'
								}}>
									<div style={{
										width: 8,
										height: 8,
										borderRadius: '50%',
										backgroundColor: '#FFA500',
										animation: 'pulse 1.5s infinite'
									}} />
									<Typography
										variant="body2"
										className="head-font"
										style={{
											color: '#FFA500',
											fontWeight: 700,
											fontSize: '0.9rem'
										}}
									>
										{t("Waiting for Preparation")}
									</Typography>
								</div>

								{/* Order details */}
								<div className="alignByLang" style={{ marginBottom: '16px' }}>
									<Typography
										variant="body2"
										className="head-font"
										style={{
											color: setMobileTextColor(),
											fontWeight: 600,
											marginBottom: '4px',
											fontSize: '0.95rem'
										}}
									>
										{t("Order Number :")} {currentOrder?.number || 'N/A'}
									</Typography>

									{currentOrder?.items && (
										<Typography
											variant="caption"
											className="sub-font"
											style={{
												color: setMobileTextColor(),
												opacity: 0.7,
												lineHeight: 1.4,
												fontSize: '0.8rem'
											}}
										>
											{currentOrder.items.slice(0, 2).map(item => item.name).join(', ')}
											{currentOrder.items.length > 2 && '...'}
										</Typography>
									)}
								</div>

								{/* Estimated time */}
								<div className="alignByLang" style={{
									display: 'flex',
									alignItems: 'center',
									gap: '10px',
									padding: '12px',
									backgroundColor: `${setMobileButttonBackColor()}08`,
									borderRadius: '8px',
									borderLeft: `3px solid ${setMobileButttonBackColor()}`
								}}>
									<Schedule sx={{
										fontSize: 20,
										color: setMobileButttonBackColor(),
										opacity: 0.9
									}} />
									<div>
										<Typography
											variant="caption"
											className="head-font"
											style={{
												color: setMobileTextColor(),
												fontWeight: 600,
												marginBottom: '2px',
												fontSize: '0.75rem',
												opacity: 0.8
											}}
										>
											{t("Estimated Preparation Time")}
										</Typography>
										<Typography
											variant="body2"
											className="sub-font"
											style={{
												color: setMobileButttonBackColor(),
												fontWeight: 700,
												fontSize: '0.9rem'
											}}
										>
											{calculateEstimatedTime(currentOrder)} {t("minutes")}
										</Typography>
									</div>
								</div>

								{/* Order type specific message */}
								<div className="alignByLang" style={{
									marginTop: '12px',
									padding: '8px',
									backgroundColor: `${setMobileCardBorderColor()}10`,
									borderRadius: '6px',
								}}>
									<Typography
										variant="caption"
										className="sub-font"
										style={{
											color: setMobileTextColor(),
											opacity: 0.8,
											fontSize: '0.75rem'
										}}
									>
										{currentOrder?.type === 'dinein' ? t("Your table will be served when ready") :
											currentOrder?.type === 'pickup' ? t("We'll notify you when ready for pickup") :
												t("Delivery will start after preparation")}
									</Typography>
								</div>
							</motion.div>

							{/* Animation based on order type */}
							<div style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								margin: '8px 0 4px',
								height: 30
							}}>
								{currentOrder?.type === 'dinein' ? (
									<motion.div
										animate={{
											scale: [1, 1.1, 1],
										}}
										transition={{
											duration: 2,
											repeat: Infinity,
											ease: "easeInOut"
										}}
									>
										<Restaurant sx={{
											fontSize: 24,
											color: setMobileButttonBackColor(),
											opacity: 0.7
										}} />
									</motion.div>
								) : currentOrder?.type === 'pickup' ? (
									<motion.div
										animate={{
											x: [-10, 10, -10],
										}}
										transition={{
											duration: 2,
											repeat: Infinity,
											ease: "easeInOut"
										}}
									>
										<TakeoutDining sx={{
											fontSize: 24,
											color: setMobileButttonBackColor(),
											opacity: 0.7
										}} />
									</motion.div>
								) : (
									<motion.div
										animate={{
											rotate: [0, 360],
										}}
										transition={{
											duration: 4,
											repeat: Infinity,
											ease: "linear"
										}}
									>
										<Schedule sx={{
											fontSize: 24,
											color: setMobileButttonBackColor(),
											opacity: 0.7
										}} />
									</motion.div>
								)}
							</div>
						</DialogContent>

						<DialogActions sx={{
							padding: '5px 20px 5px',
							justifyContent: 'center'
						}}>
							<motion.div
								whileHover={{ scale: 1.03 }}
								whileTap={{ scale: 0.97 }}
							>
								<Button
									onClick={() => setShowWaitingDialog(false)}
									variant="contained"
									sx={{
										backgroundColor: setMobileButttonBackColor(),
										color: setMobileHighlightTextColor() || '#fff',
										padding: '8px 24px',
										borderRadius: '8px',
										fontWeight: 600,
										fontSize: '0.9rem',
										textTransform: 'none',
										minWidth: 120,
										'&:hover': {
											backgroundColor: setMobileButttonBackColor(),
											opacity: 0.9,
										}
									}}
									className="head-font"
								>
									{t("Got It")}
								</Button>
							</motion.div>
						</DialogActions>
					</motion.div>
				</Dialog>

				{/* Preparing Order Dialog */}
				<Dialog
					open={showPreparingDialog && currentOrder}
					onClose={() => setShowPreparingDialog(false)}
					maxWidth="sm"
					fullWidth
					PaperProps={{
						style: {
							borderRadius: 16,
							overflow: 'hidden',
							backgroundColor: setMobileBackColor(),
							border: `2px solid ${setMobileButttonBackColor()}`,
							maxHeight: '98vh',
						},
					}}
				>
					<motion.div
						initial={{ opacity: 0, scale: 0.9 }}
						animate={{ opacity: 1, scale: 1 }}
						transition={{ duration: 0.3 }}
					>
						{/* Header based on order type */}
						<div style={{
							background: `linear-gradient(135deg, ${setMobileButttonBackColor()} 0%, ${setMobileBackColor() || setMobileButttonBackColor()} 100%)`, padding: '20px',
							textAlign: 'center',
							position: 'relative',
						}}>
							{/* Animated cooking icon */}
							<motion.div
								animate={{
									rotate: [0, 10, -10, 0],
								}}
								transition={{
									duration: 2,
									repeat: Infinity,
									ease: "easeInOut"
								}}
								style={{
									marginBottom: '12px'
								}}
							>
								<LocalDining sx={{
									fontSize: 48,
									color: setMobileButttonBackColor(),
									filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
								}} />
							</motion.div>

							<Typography
								variant="h6"
								className="head-font"
								style={{
									color: setMobileTextColor(),
									fontWeight: 700,
									marginBottom: '4px',
									fontSize: '1.25rem'
								}}
							>
								{currentOrder?.type === 'dinein' ? t("Dine In Order in Preparation") :
									currentOrder?.type === 'pickup' ? t("Pickup Order in Preparation") :
										t("Delivery Order in Preparation")}
							</Typography>

							<Typography
								variant="caption"
								className="sub-font"
								style={{
									color: setMobileButttonBackColor(),
									fontWeight: 500,
									fontSize: '0.85rem'
								}}
							>
								{t("Your order is being prepared now")}
							</Typography>
						</div>

						<DialogContent sx={{
							padding: '20px 20px 0px 20px !important',
							'&.MuiDialogContent-root': {
								paddingBottom: '0px !important'
							}
						}}>
							{/* Progress indicator */}
							<motion.div
								initial={{ scaleX: 0 }}
								animate={{ scaleX: 1 }}
								transition={{ duration: 0.6 }}
								style={{
									height: 4,
									background: `linear-gradient(90deg, ${setMobileButttonBackColor()} 0%, ${setMobileHighlightTextColor() || setMobileButttonBackColor()} 100%)`, borderRadius: 2,
									marginBottom: 20,
									transformOrigin: 'left'
								}}
							/>

							{/* Order status card */}
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ duration: 0.3, delay: 0.2 }}
								style={{
									backgroundColor: setMobileCardColor(),
									borderRadius: 12,
									padding: '16px',
									border: `1px solid ${setMobileCardBorderColor()}`,
									boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
								}}
							>
								{/* Status badge */}
								<div className="alignByLang" style={{
									display: 'flex',
									alignItems: 'center',
									gap: '8px',
									marginBottom: '16px'
								}}>
									<motion.div
										animate={{
											scale: [1, 1.2, 1],
										}}
										transition={{
											duration: 1,
											repeat: Infinity,
											ease: "easeInOut"
										}}
										style={{
											width: 8,
											height: 8,
											borderRadius: '50%',
											backgroundColor: '#4CAF50',
										}}
									/>
									<Typography
										variant="body2"
										className="head-font"
										style={{
											color: '#4CAF50',
											fontWeight: 700,
											fontSize: '0.9rem'
										}}
									>
										{t("In Preparation")}
									</Typography>
								</div>

								{/* Order details */}
								<div className="alignByLang" style={{ marginBottom: '16px' }}>
									<Typography
										variant="body2"
										className="head-font"
										style={{
											color: setMobileTextColor(),
											fontWeight: 600,
											marginBottom: '4px',
											fontSize: '0.95rem'
										}}
									>
										{t("Order Number :")} {currentOrder?.number || 'N/A'}
									</Typography>

									{currentOrder?.items && (
										<Typography
											variant="caption"
											className="sub-font"
											style={{
												color: setMobileTextColor(),
												opacity: 0.7,
												lineHeight: 1.4,
												fontSize: '0.8rem'
											}}
										>
											{currentOrder.items.slice(0, 2).map(item => item.name).join(', ')}
											{currentOrder.items.length > 2 && '...'}
										</Typography>
									)}
								</div>

								{/* Estimated time */}
								<div className="alignByLang" style={{
									display: 'flex',
									alignItems: 'center',
									gap: '10px',
									padding: '12px',
									backgroundColor: '#4CAF5010',
									borderRadius: '8px',
									borderLeft: `3px solid #4CAF50`
								}}>
									<Schedule sx={{
										fontSize: 20,
										color: '#4CAF50',
										opacity: 0.9
									}} />
									<div>
										<Typography
											variant="caption"
											className="head-font"
											style={{
												color: setMobileTextColor(),
												fontWeight: 600,
												marginBottom: '2px',
												fontSize: '0.75rem',
												opacity: 0.8
											}}
										>
											{t("Estimated Completion Time")}
										</Typography>
										<Typography
											variant="body2"
											className="sub-font"
											style={{
												color: '#4CAF50',
												fontWeight: 700,
												fontSize: '0.9rem'
											}}
										>
											{calculateEstimatedTime(currentOrder)} {t("minutes")}
										</Typography>
									</div>
								</div>

								{/* Progress bar */}
								<div className="alignByLang" style={{
									marginTop: '16px',
								}}>
									<Typography
										variant="caption"
										className="sub-font"
										style={{
											color: setMobileTextColor(),
											fontWeight: 600,
											marginBottom: '8px',
											fontSize: '0.75rem',
											display: 'block'
										}}
									>
										{t("Preparation Progress")}
									</Typography>
									<motion.div
										initial={{ width: '0%' }}
										animate={{ width: '60%' }}
										transition={{ duration: 2, ease: "easeInOut" }}
										style={{
											height: 6,
											backgroundColor: '#4CAF50',
											borderRadius: 3,
										}}
									/>
								</div>

								{/* Order type specific message */}
								<div className="alignByLang" style={{
									marginTop: '12px',
									padding: '8px',
									backgroundColor: `${setMobileCardBorderColor()}10`,
									borderRadius: '6px',
								}}>
									<Typography
										variant="caption"
										className="sub-font"
										style={{
											color: setMobileTextColor(),
											opacity: 0.8,
											fontSize: '0.75rem'
										}}
									>
										{currentOrder?.type === 'dinein' ? t("Chefs are preparing your meal") :
											currentOrder?.type === 'pickup' ? t("Your order will be ready for pickup soon") :
												t("Delivery will depart after preparation")}
									</Typography>
								</div>
							</motion.div>

							{/* Cooking animation */}
							<div style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								margin: '8px 0 4px',
								height: 40
							}}>
								<motion.div
									animate={{
										rotate: [0, 360],
									}}
									transition={{
										duration: 3,
										repeat: Infinity,
										ease: "linear"
									}}
								>
									<Restaurant sx={{
										fontSize: 30,
										color: '#4CAF50',
										opacity: 0.7
									}} />
								</motion.div>
								<motion.div
									animate={{
										y: [0, -5, 0],
									}}
									transition={{
										duration: 0.5,
										repeat: Infinity,
										ease: "easeInOut"
									}}
									style={{
										margin: '0 10px'
									}}
								>
									<LocalDining sx={{
										fontSize: 30,
										color: '#4CAF50',
										opacity: 0.7
									}} />
								</motion.div>
								<motion.div
									animate={{
										scale: [1, 1.2, 1],
									}}
									transition={{
										duration: 1,
										repeat: Infinity,
										ease: "easeInOut"
									}}
								>
									<TakeoutDining sx={{
										fontSize: 30,
										color: '#4CAF50',
										opacity: 0.7
									}} />
								</motion.div>
							</div>
						</DialogContent>

						<DialogActions sx={{
							padding: '5px 20px 5px',
							justifyContent: 'center'
						}}>
							<motion.div
								whileHover={{ scale: 1.03 }}
								whileTap={{ scale: 0.97 }}
							>
								<Button
									onClick={() => setShowPreparingDialog(false)}
									variant="contained"
									sx={{
										backgroundColor: '#4CAF50',
										color: '#fff',
										padding: '8px 24px',
										borderRadius: '8px',
										fontWeight: 600,
										fontSize: '0.9rem',
										textTransform: 'none',
										minWidth: 120,
										'&:hover': {
											backgroundColor: '#388E3C',
										}
									}}
									className="head-font"
								>
									{t("Got It")}
								</Button>
							</motion.div>
						</DialogActions>
					</motion.div>
				</Dialog>



				<LocationDistanceDialog
					open={locationDistanceDialogOpen}
					onClose={handleLocationDistanceCancel}
					onChangeAddresss={() => setDeliveryDialogOpen(true)}
					onConfirm={handleLocationDistanceConfirm}
					onCancel={handleLocationDistanceCancel}
				/>
			</div>
		</div>

	);
};

export default WellcomeScreen;